[
  {
    "unlocode": "RUBRK",
    "label": "Lomonosov",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "CNSHA",
    "label": "Shanghai",
    "region": "North East Asia",
    "country": "China",
    "score": 10990
  },
  {
    "unlocode": "CNNGB",
    "label": "Ningbo",
    "region": "North East Asia",
    "country": "China",
    "score": 8157
  },
  {
    "unlocode": "CNTAO",
    "label": "Qingdao",
    "region": "North East Asia",
    "country": "China",
    "score": 7770
  },
  {
    "unlocode": "CNSNZ",
    "label": "Shenzhen",
    "region": "North East Asia",
    "country": "China",
    "score": 4446
  },
  {
    "unlocode": "CNTSN",
    "label": "Tianjin",
    "region": "North East Asia",
    "country": "China",
    "score": 3039
  },
  {
    "unlocode": "CNXMN",
    "label": "Xiamen",
    "region": "North East Asia",
    "country": "China",
    "score": 2776
  },
  {
    "unlocode": "CNYTN",
    "label": "Yantian",
    "region": "North East Asia",
    "country": "China",
    "score": 2594
  },
  {
    "unlocode": "BEANR",
    "label": "Antwerp",
    "region": "Europe North",
    "country": "Belgium",
    "score": 2379
  },
  {
    "unlocode": "NLRTM",
    "label": "Rotterdam",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 2325
  },
  {
    "unlocode": "RUMOW",
    "label": "Moscow",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 2185
  },
  {
    "unlocode": "AEDXB",
    "label": "Dubai",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 1937
  },
  {
    "unlocode": "CNSHK",
    "label": "Shekou",
    "region": "North East Asia",
    "country": "China",
    "score": 1447
  },
  {
    "unlocode": "CNCAN",
    "label": "Guangzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 1383
  },
  {
    "unlocode": "CNCKG",
    "label": "Chongqing",
    "region": "North East Asia",
    "country": "China",
    "score": 1346
  },
  {
    "unlocode": "DEHAM",
    "label": "Hamburg",
    "region": "Europe North",
    "country": "Germany",
    "score": 1334
  },
  {
    "unlocode": "DEDUI",
    "label": "Duisburg",
    "region": "Europe North",
    "country": "Germany",
    "score": 1291
  },
  {
    "unlocode": "CNZHE",
    "label": "Zhenjiang",
    "region": "North East Asia",
    "country": "China",
    "score": 1226
  },
  {
    "unlocode": "CNTAG",
    "label": "Taicang",
    "region": "North East Asia",
    "country": "China",
    "score": 1219
  },
  {
    "unlocode": "CNTXG",
    "label": "Tianjinxingang",
    "region": "North East Asia",
    "country": "China",
    "score": 1212
  },
  {
    "unlocode": "CNDLC",
    "label": "Dalian",
    "region": "North East Asia",
    "country": "China",
    "score": 1203
  },
  {
    "unlocode": "CNKUS",
    "label": "Kunshan",
    "region": "North East Asia",
    "country": "China",
    "score": 1160
  },
  {
    "unlocode": "CNFOS",
    "label": "Foshan",
    "region": "North East Asia",
    "country": "China",
    "score": 1129
  },
  {
    "unlocode": "CNHRB",
    "label": "Harbin",
    "region": "North East Asia",
    "country": "China",
    "score": 1126
  },
  {
    "unlocode": "CNHME",
    "label": "Haimen",
    "region": "North East Asia",
    "country": "China",
    "score": 1125
  },
  {
    "unlocode": "CNZZU",
    "label": "Zhangzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 1125
  },
  {
    "unlocode": "CNXGG",
    "label": "Xingang",
    "region": "North East Asia",
    "country": "China",
    "score": 1106
  },
  {
    "unlocode": "CNXIA",
    "label": "Xian",
    "region": "North East Asia",
    "country": "China",
    "score": 1076
  },
  {
    "unlocode": "CNNTG",
    "label": "Nantong",
    "region": "North East Asia",
    "country": "China",
    "score": 1026
  },
  {
    "unlocode": "PLMAA",
    "label": "Malaszewicze",
    "region": "Europe North",
    "country": "Poland",
    "score": 1019
  },
  {
    "unlocode": "CNFZH",
    "label": "Fuzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 970
  },
  {
    "unlocode": "CNHUI",
    "label": "Huizhou",
    "region": "North East Asia",
    "country": "China",
    "score": 896
  },
  {
    "unlocode": "CNHGH",
    "label": "Hangzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 895
  },
  {
    "unlocode": "CNCGU",
    "label": "Changshu",
    "region": "North East Asia",
    "country": "China",
    "score": 891
  },
  {
    "unlocode": "CNZJG",
    "label": "Zhangjiagang",
    "region": "North East Asia",
    "country": "China",
    "score": 890
  },
  {
    "unlocode": "CNSWA",
    "label": "Shantou",
    "region": "North East Asia",
    "country": "China",
    "score": 878
  },
  {
    "unlocode": "CNCTU",
    "label": "Chengdu",
    "region": "North East Asia",
    "country": "China",
    "score": 816
  },
  {
    "unlocode": "CNSHE",
    "label": "Shenyang",
    "region": "North East Asia",
    "country": "China",
    "score": 733
  },
  {
    "unlocode": "VNSGN",
    "label": "Ho Chi Minh City",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 686
  },
  {
    "unlocode": "CNDGG",
    "label": "Dongguan",
    "region": "North East Asia",
    "country": "China",
    "score": 661
  },
  {
    "unlocode": "CNHUA",
    "label": "Huangpu",
    "region": "North East Asia",
    "country": "China",
    "score": 653
  },
  {
    "unlocode": "CNNSA",
    "label": "Nansha",
    "region": "North East Asia",
    "country": "China",
    "score": 595
  },
  {
    "unlocode": "RULED",
    "label": "St Petersburg",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 548
  },
  {
    "unlocode": "MYPKG",
    "label": "Port Kelang",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 527
  },
  {
    "unlocode": "CNSZH",
    "label": "Suzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 495
  },
  {
    "unlocode": "CNCGO",
    "label": "Zhengzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 490
  },
  {
    "unlocode": "INMUN",
    "label": "Mundra",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 487
  },
  {
    "unlocode": "INNSA",
    "label": "Nhava Sheva",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 481
  },
  {
    "unlocode": "CNYIW",
    "label": "Yiwu",
    "region": "North East Asia",
    "country": "China",
    "score": 473
  },
  {
    "unlocode": "CNNKG",
    "label": "Nanjing",
    "region": "North East Asia",
    "country": "China",
    "score": 461
  },
  {
    "unlocode": "CNJIA",
    "label": "Jiangyin (Shanghai)",
    "region": "North East Asia",
    "country": "China",
    "score": 351
  },
  {
    "unlocode": "HKHKG",
    "label": "Hong Kong",
    "region": "North East Asia",
    "country": "Hong Kong",
    "score": 333
  },
  {
    "unlocode": "CNWUH",
    "label": "Wuhan",
    "region": "North East Asia",
    "country": "China",
    "score": 329
  },
  {
    "unlocode": "VNHPH",
    "label": "Haiphong",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 325
  },
  {
    "unlocode": "PLWAW",
    "label": "Warsaw",
    "region": "Europe North",
    "country": "Poland",
    "score": 309
  },
  {
    "unlocode": "FRLEH",
    "label": "Le Havre",
    "region": "Europe North",
    "country": "France",
    "score": 294
  },
  {
    "unlocode": "HUBUD",
    "label": "Budapest",
    "region": "Europe North",
    "country": "Hungary",
    "score": 244
  },
  {
    "unlocode": "ESVLC",
    "label": "Valencia (Spain)",
    "region": "Europe Med",
    "country": "Spain",
    "score": 239
  },
  {
    "unlocode": "KRPUS",
    "label": "Busan, Korea",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 222
  },
  {
    "unlocode": "CNLYG",
    "label": "Lianyungang",
    "region": "North East Asia",
    "country": "China",
    "score": 213
  },
  {
    "unlocode": "PLGDN",
    "label": "Gdansk",
    "region": "Europe North",
    "country": "Poland",
    "score": 213
  },
  {
    "unlocode": "TWKHH",
    "label": "Kaohsiung",
    "region": "North East Asia",
    "country": "Taiwan",
    "score": 202
  },
  {
    "unlocode": "INMAA",
    "label": "Chennai",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 200
  },
  {
    "unlocode": "CNZUH",
    "label": "Zhuhai",
    "region": "North East Asia",
    "country": "China",
    "score": 182
  },
  {
    "unlocode": "SGSIN",
    "label": "Singapore",
    "region": "South East Asia",
    "country": "Singapore",
    "score": 173
  },
  {
    "unlocode": "ITMIL",
    "label": "Milano",
    "region": "Europe Med",
    "country": "Italy",
    "score": 172
  },
  {
    "unlocode": "PKKHI",
    "label": "Karachi",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 171
  },
  {
    "unlocode": "CNHFE",
    "label": "Hefei Xinqiao International Apt",
    "region": "North East Asia",
    "country": "China",
    "score": 159
  },
  {
    "unlocode": "AEJEA",
    "label": "Jebel Ali",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 155
  },
  {
    "unlocode": "CNCSX",
    "label": "Changsha",
    "region": "North East Asia",
    "country": "China",
    "score": 154
  },
  {
    "unlocode": "TRIST",
    "label": "Istanbul",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 153
  },
  {
    "unlocode": "CNZSN",
    "label": "Zhongshan",
    "region": "North East Asia",
    "country": "China",
    "score": 151
  },
  {
    "unlocode": "CNZAP",
    "label": "Zhapu",
    "region": "North East Asia",
    "country": "China",
    "score": 148
  },
  {
    "unlocode": "CNWUX",
    "label": "Wuxi",
    "region": "North East Asia",
    "country": "China",
    "score": 147
  },
  {
    "unlocode": "CNTZO",
    "label": "Taizhou",
    "region": "North East Asia",
    "country": "China",
    "score": 141
  },
  {
    "unlocode": "CNYZH",
    "label": "Yangzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 128
  },
  {
    "unlocode": "CNURM",
    "label": "Urumqi",
    "region": "North East Asia",
    "country": "China",
    "score": 128
  },
  {
    "unlocode": "CNJIU",
    "label": "Jiujiang (Jiangxi)",
    "region": "North East Asia",
    "country": "China",
    "score": 125
  },
  {
    "unlocode": "RUYEK",
    "label": "Yekaterinburg, Sve",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 121
  },
  {
    "unlocode": "CNYUY",
    "label": "Yueyang",
    "region": "North East Asia",
    "country": "China",
    "score": 116
  },
  {
    "unlocode": "CNCZX",
    "label": "Changzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 115
  },
  {
    "unlocode": "CNWNZ",
    "label": "Wenzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 115
  },
  {
    "unlocode": "IDJKT",
    "label": "Jakarta",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 114
  },
  {
    "unlocode": "RUVVO",
    "label": "Vladivostok",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 114
  },
  {
    "unlocode": "CNDCB",
    "label": "Dachan Bay",
    "region": "North East Asia",
    "country": "China",
    "score": 113
  },
  {
    "unlocode": "CNFOC",
    "label": "Mawei Fuzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 113
  },
  {
    "unlocode": "CNYPG",
    "label": "Yangpu",
    "region": "North East Asia",
    "country": "China",
    "score": 113
  },
  {
    "unlocode": "CNZHA",
    "label": "Zhanjiang",
    "region": "North East Asia",
    "country": "China",
    "score": 113
  },
  {
    "unlocode": "CNJIX",
    "label": "Jiaxing",
    "region": "North East Asia",
    "country": "China",
    "score": 112
  },
  {
    "unlocode": "CNKHN",
    "label": "Nanchang",
    "region": "North East Asia",
    "country": "China",
    "score": 112
  },
  {
    "unlocode": "RUOVB",
    "label": "Novosibirsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 112
  },
  {
    "unlocode": "CNYAN",
    "label": "Yangshan",
    "region": "North East Asia",
    "country": "China",
    "score": 110
  },
  {
    "unlocode": "DENUE",
    "label": "Nurnberg",
    "region": "Europe North",
    "country": "Germany",
    "score": 110
  },
  {
    "unlocode": "CNDFE",
    "label": "Dafeng",
    "region": "North East Asia",
    "country": "China",
    "score": 109
  },
  {
    "unlocode": "CNHSN",
    "label": "Heshan",
    "region": "North East Asia",
    "country": "China",
    "score": 109
  },
  {
    "unlocode": "CNBHY",
    "label": "Beihai",
    "region": "North East Asia",
    "country": "China",
    "score": 108
  },
  {
    "unlocode": "CNSIA",
    "label": "Xi An",
    "region": "North East Asia",
    "country": "China",
    "score": 108
  },
  {
    "unlocode": "CNAQG",
    "label": "Anqing",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNBAY",
    "label": "Bayuquan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNBEI",
    "label": "Beilun",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNCDE",
    "label": "Changde",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNCLJ",
    "label": "Chenglingji",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNCWN",
    "label": "Chiwan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNCZ1",
    "label": "Chizhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNDOU",
    "label": "Doumen",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNFAN",
    "label": "Fangcheng",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNFLG",
    "label": "Fuling",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNFNG",
    "label": "Fuyong",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNFUG",
    "label": "Jiangyin, Fuqing, Fuzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNGGY",
    "label": "Gongyi",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNGOM",
    "label": "Gaoming",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNGON",
    "label": "Gaolan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNGUG",
    "label": "Guigang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHAK",
    "label": "Haikou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHSI",
    "label": "Huangshi",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHUD",
    "label": "Hua Du",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHZH",
    "label": "Huzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJGZ",
    "label": "Jingzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJIN",
    "label": "Jingtang (Tangshan)",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJJG",
    "label": "Jiujiang (Guangdong)",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJMN",
    "label": "Jiangmen",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJNZ",
    "label": "Jinzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJZU",
    "label": "Jiuzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNKMG",
    "label": "Kunming",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNKPN",
    "label": "Kaiping",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLAN",
    "label": "Lanshi",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLIH",
    "label": "Lianhuashan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLKU",
    "label": "Longkou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLUD",
    "label": "Liudu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLUU",
    "label": "Leliu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLZH",
    "label": "Liuzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLZU",
    "label": "Luzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNMAA",
    "label": "Maanshan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNMCH",
    "label": "Machong",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNMFG",
    "label": "Mafang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNMMI",
    "label": "Maoming",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNMWN",
    "label": "Mawan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNMYG",
    "label": "Mianyang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNNAH",
    "label": "Nanhai",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNNGG",
    "label": "Nangang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNNNG",
    "label": "Nanning",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNPNY",
    "label": "Panyu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNQYN",
    "label": "Qingyuan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNQZH",
    "label": "Qinzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNQZJ",
    "label": "Quanzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNROQ",
    "label": "Rongqi",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNRZH",
    "label": "Rizhao",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSBU",
    "label": "Sanbu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSDG",
    "label": "Shuidong",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSHD",
    "label": "Shidao",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSHG",
    "label": "Sanshan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSHP",
    "label": "Qinhuangdao",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSHS",
    "label": "Shashi",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSHW",
    "label": "Honghai",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSIN",
    "label": "Shatian",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSJQ",
    "label": "Sanshui",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSR9",
    "label": "Shangrao",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSUD",
    "label": "Shunde",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSUI",
    "label": "Suigang Huangpu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNTAP",
    "label": "Taiping",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNTAS",
    "label": "Tangshan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNTHG",
    "label": "Taicheng",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNTOL",
    "label": "Tongling",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNWAH",
    "label": "Wanzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNWAZ",
    "label": "Wanzai",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNWEI",
    "label": "Weihai",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNWHI",
    "label": "Wuhu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNWTU",
    "label": "Weitou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNWUZ",
    "label": "Wuzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXAB",
    "label": "Xinfeng",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXIL",
    "label": "Xiaolan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXIN",
    "label": "Xinhui",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXIT",
    "label": "Xintang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXIU",
    "label": "Xiuyu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXTA",
    "label": "Xiangtan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYBN",
    "label": "Yibin",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYIC",
    "label": "Yichang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYIK",
    "label": "Yingkou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYJI",
    "label": "Yangjiang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYNF",
    "label": "Yunfu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYNT",
    "label": "Yantai",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYQS",
    "label": "Beijiao",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNZIB",
    "label": "Zibo",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNZQG",
    "label": "Zhaoqing",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNZUU",
    "label": "Zhuzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJGY",
    "label": "Jiangyin (Fujian)",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXZU",
    "label": "Xiangzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSIH",
    "label": "Sihui",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNFGN",
    "label": "Fangcun",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNJXN",
    "label": "Jiao Xin",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLSI",
    "label": "Lanshi",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNQLU",
    "label": "Qingliu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNCHH",
    "label": "Chengcheng",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNLUZ",
    "label": "Luzhou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNWAN",
    "label": "Wanding",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNBOT",
    "label": "Baotou",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYXS",
    "label": "Yixing",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYNJ",
    "label": "Yanji",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNDDZ",
    "label": "Dandong",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHUH",
    "label": "Huanghua",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSJZ",
    "label": "Shijiazhuang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNTYU",
    "label": "Taiyuan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNYCH",
    "label": "Yinchuan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHNY",
    "label": "Hengyang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNPUT",
    "label": "Putian",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHSC",
    "label": "Shaoguan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHNG",
    "label": "Henggang",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNXNY",
    "label": "Xinyi",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNHDU",
    "label": "Huadu",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNTSG",
    "label": "Gongyi (China)",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNFUT",
    "label": "Futian",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNSFH",
    "label": "Suifenhe",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "CNDSZ",
    "label": "Dushan",
    "region": "North East Asia",
    "country": "China",
    "score": 107
  },
  {
    "unlocode": "THLCH",
    "label": "Laem Chabang",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 105
  },
  {
    "unlocode": "KZALA",
    "label": "Almaty",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 103
  },
  {
    "unlocode": "ATLNZ",
    "label": "Linz",
    "region": "Europe North",
    "country": "Austria",
    "score": 99
  },
  {
    "unlocode": "TWKEL",
    "label": "Keelung",
    "region": "North East Asia",
    "country": "Taiwan",
    "score": 96
  },
  {
    "unlocode": "ESBCN",
    "label": "Barcelona (Spain)",
    "region": "Europe Med",
    "country": "Spain",
    "score": 86
  },
  {
    "unlocode": "TWTXG",
    "label": "Taichung",
    "region": "North East Asia",
    "country": "Taiwan",
    "score": 85
  },
  {
    "unlocode": "BDCGP",
    "label": "Chittagong",
    "region": "Middle East & ISC",
    "country": "Bangladesh",
    "score": 80
  },
  {
    "unlocode": "INBOM",
    "label": "Mumbai",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 73
  },
  {
    "unlocode": "CZPRG",
    "label": "Praha",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 70
  },
  {
    "unlocode": "FIHEL",
    "label": "Helsinki",
    "region": "Europe North",
    "country": "Finland",
    "score": 68
  },
  {
    "unlocode": "PLLOD",
    "label": "Lodz",
    "region": "Europe North",
    "country": "Poland",
    "score": 67
  },
  {
    "unlocode": "CAMTR",
    "label": "Montreal, QC",
    "region": "North America",
    "country": "Canada",
    "score": 65
  },
  {
    "unlocode": "GBSOU",
    "label": "Southampton",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 63
  },
  {
    "unlocode": "LKCMB",
    "label": "Colombo",
    "region": "Middle East & ISC",
    "country": "Sri Lanka",
    "score": 57
  },
  {
    "unlocode": "LTVNO",
    "label": "Vilnius",
    "region": "Europe North",
    "country": "Lithuania",
    "score": 57
  },
  {
    "unlocode": "GBFXT",
    "label": "Felixstowe",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 55
  },
  {
    "unlocode": "FRLIO",
    "label": "Lyon",
    "region": "Europe North",
    "country": "France",
    "score": 52
  },
  {
    "unlocode": "VNHAN",
    "label": "Hanoi",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 51
  },
  {
    "unlocode": "BYMSQ",
    "label": "Minsk",
    "region": "Europe North",
    "country": "Belarus",
    "score": 49
  },
  {
    "unlocode": "ITGOA",
    "label": "Genoa",
    "region": "Europe Med",
    "country": "Italy",
    "score": 49
  },
  {
    "unlocode": "RUKJA",
    "label": "Krasnojarsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 49
  },
  {
    "unlocode": "DKAAR",
    "label": "Aarhus",
    "region": "Europe North",
    "country": "Denmark",
    "score": 47
  },
  {
    "unlocode": "FRBOD",
    "label": "Bordeaux",
    "region": "Europe North",
    "country": "France",
    "score": 47
  },
  {
    "unlocode": "ITARQ",
    "label": "Arquata Scrivia",
    "region": "Europe Med",
    "country": "Italy",
    "score": 47
  },
  {
    "unlocode": "FRFOS",
    "label": "Fos Sur Mer",
    "region": "Europe North",
    "country": "France",
    "score": 46
  },
  {
    "unlocode": "RUIKT",
    "label": "Irkutsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 46
  },
  {
    "unlocode": "ATVIE",
    "label": "Vienna",
    "region": "Europe North",
    "country": "Austria",
    "score": 43
  },
  {
    "unlocode": "THBKK",
    "label": "Bangkok",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 43
  },
  {
    "unlocode": "BELGG",
    "label": "Liege",
    "region": "Europe North",
    "country": "Belgium",
    "score": 41
  },
  {
    "unlocode": "FRMRS",
    "label": "Marseille",
    "region": "Europe North",
    "country": "France",
    "score": 41
  },
  {
    "unlocode": "GBLON",
    "label": "London",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 38
  },
  {
    "unlocode": "UZTAS",
    "label": "Tashkent",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 37
  },
  {
    "unlocode": "FIOUL",
    "label": "Oulu",
    "region": "Europe North",
    "country": "Finland",
    "score": 31
  },
  {
    "unlocode": "FRGVL",
    "label": "Gennevilliers",
    "region": "Europe North",
    "country": "France",
    "score": 30
  },
  {
    "unlocode": "INDRI",
    "label": "Dadri, UP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 30
  },
  {
    "unlocode": "VNDAD",
    "label": "Da Nang",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 30
  },
  {
    "unlocode": "ATSZG",
    "label": "Salzburg",
    "region": "Europe North",
    "country": "Austria",
    "score": 29
  },
  {
    "unlocode": "FRALG",
    "label": "Ambares-Et-Lagrave",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRANE",
    "label": "Angers",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRANG",
    "label": "Angouleme",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRBAS",
    "label": "Bassens",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRBAY",
    "label": "Bayonne",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRBES",
    "label": "Brest",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRBRU",
    "label": "Bruges/Bordeaux",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRBSM",
    "label": "Bonneuil Sur Marne",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRCER",
    "label": "Cherbourg",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRCFE",
    "label": "Clermont Ferrand",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRCGO",
    "label": "Chateau Gontier",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRCNG",
    "label": "Cognac",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRCSS",
    "label": "Chalon Sur Saone",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRDGS",
    "label": "Dourges",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRDIJ",
    "label": "Dijon",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRDKK",
    "label": "Dunkerque",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRGGN",
    "label": "Gignac",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRGNB",
    "label": "Grenoble",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRGRC",
    "label": "Grand Couronne",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRGRZ",
    "label": "Gerzat",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRHON",
    "label": "Honfleur",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRLLE",
    "label": "Lille",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRLMY",
    "label": "Limay",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRLPE",
    "label": "La Pallice",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRLRH",
    "label": "La Rochelle",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRLUL",
    "label": "Les Ulis",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRLVA",
    "label": "Laval",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRMAC",
    "label": "Macon",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRMAZ",
    "label": "Mazamet",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRMPL",
    "label": "Montpellier",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRMTX",
    "label": "Montoir De Bretagne",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRNCE",
    "label": "Nice",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRNGS",
    "label": "Nogent Sur Seine",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRNTE",
    "label": "Nantes",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRORR",
    "label": "Orleans",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FROTM",
    "label": "Ottmarsheim",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRPAR",
    "label": "Paris",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRPLI",
    "label": "Plaisir",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRPOV",
    "label": "Port Vendres",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRPOY",
    "label": "Prouvy",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRPSL",
    "label": "Port St Louis Du Rhone",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRRNS",
    "label": "Rennes",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRSET",
    "label": "Sete",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRSOI",
    "label": "Soissons",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRSUN",
    "label": "Suresnes",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRSVD",
    "label": "St Vigor D'Ymonville",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRSXB",
    "label": "Strasbourg",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRTLS",
    "label": "Toulouse",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRTUF",
    "label": "Tours",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRURO",
    "label": "Rouen",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRVAF",
    "label": "Valence",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRVEA",
    "label": "Veauche",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRVEL",
    "label": "Vesoul",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRYNE",
    "label": "La Seyne",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FR3CD",
    "label": "Chaudron En Mauges",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "INHZA",
    "label": "Hazira, GJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 28
  },
  {
    "unlocode": "PLKUT",
    "label": "Kutno",
    "region": "Europe North",
    "country": "Poland",
    "score": 28
  },
  {
    "unlocode": "FRGGM",
    "label": "Chaudron En Mauges, Maine-Et-Loire",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRLYN",
    "label": "Bron Apt/Lyon",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRPZQ",
    "label": "Plounevez-Quintin",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRVGL",
    "label": "Volgelsheim",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRSJY",
    "label": "St Jean D'Angely",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRCET",
    "label": "Cholet",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRCLR",
    "label": "Chatenoy Le Royal",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRSPD",
    "label": "St Pierre Des Corps",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRBUZ",
    "label": "Bruz",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRNIP",
    "label": "Saint-Nicolas-Du-Pelem",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRBGR",
    "label": "BruguiÃ£Ë†Res",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRYFE",
    "label": "Sainte-Feyre",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRMZM",
    "label": "Metz",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRNEF",
    "label": "Neuf Brisach",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRPGK",
    "label": "Perrigny",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRMCQ",
    "label": "Macau (France)",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "FRGEC",
    "label": "Gevrey-Chambertin",
    "region": "Europe North",
    "country": "France",
    "score": 28
  },
  {
    "unlocode": "NOKRS",
    "label": "Kristiansand",
    "region": "Europe North",
    "country": "Norway",
    "score": 26
  },
  {
    "unlocode": "PLGDY",
    "label": "Gdynia",
    "region": "Europe North",
    "country": "Poland",
    "score": 25
  },
  {
    "unlocode": "DEMUC",
    "label": "Munich",
    "region": "Europe North",
    "country": "Germany",
    "score": 24
  },
  {
    "unlocode": "INCCU",
    "label": "Kolkata(Calcutta)",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 22
  },
  {
    "unlocode": "TRAVC",
    "label": "Istanbul, Ambarli Port E. Side",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 22
  },
  {
    "unlocode": "DEREG",
    "label": "Regensburg",
    "region": "Europe North",
    "country": "Germany",
    "score": 21
  },
  {
    "unlocode": "DKFRC",
    "label": "Fredericia",
    "region": "Europe North",
    "country": "Denmark",
    "score": 21
  },
  {
    "unlocode": "IEDUB",
    "label": "Dublin",
    "region": "Europe North",
    "country": "Ireland",
    "score": 21
  },
  {
    "unlocode": "KEMBA",
    "label": "Mombasa",
    "region": "East Africa",
    "country": "Kenya",
    "score": 20
  },
  {
    "unlocode": "RUNVS",
    "label": "Novorossiysk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 20
  },
  {
    "unlocode": "ESTAR",
    "label": "Tarragona",
    "region": "Europe Med",
    "country": "Spain",
    "score": 19
  },
  {
    "unlocode": "ILASH",
    "label": "Ashdod",
    "region": "Middle East & ISC",
    "country": "Israel",
    "score": 18
  },
  {
    "unlocode": "CATOR",
    "label": "Toronto, ON",
    "region": "North America",
    "country": "Canada",
    "score": 17
  },
  {
    "unlocode": "INTUT",
    "label": "Tuticorin",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 17
  },
  {
    "unlocode": "ITNOL",
    "label": "Nola",
    "region": "Europe Med",
    "country": "Italy",
    "score": 17
  },
  {
    "unlocode": "TRIZM",
    "label": "Izmir",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 17
  },
  {
    "unlocode": "BGDNJ",
    "label": "Devnya",
    "region": "Europe Med",
    "country": "Bulgaria",
    "score": 16
  },
  {
    "unlocode": "INDEL",
    "label": "Delhi",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 16
  },
  {
    "unlocode": "INIXY",
    "label": "Kandla",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 16
  },
  {
    "unlocode": "LTKLJ",
    "label": "Klaipeda",
    "region": "Europe North",
    "country": "Lithuania",
    "score": 16
  },
  {
    "unlocode": "INICD",
    "label": "New Delhi",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 16
  },
  {
    "unlocode": "BDDAC",
    "label": "Dhaka",
    "region": "Middle East & ISC",
    "country": "Bangladesh",
    "score": 15
  },
  {
    "unlocode": "BDMGL",
    "label": "Mongla",
    "region": "Middle East & ISC",
    "country": "Bangladesh",
    "score": 15
  },
  {
    "unlocode": "BGSOF",
    "label": "Sofia",
    "region": "Europe Med",
    "country": "Bulgaria",
    "score": 15
  },
  {
    "unlocode": "BGVAR",
    "label": "Varna",
    "region": "Europe Med",
    "country": "Bulgaria",
    "score": 15
  },
  {
    "unlocode": "CHBSL",
    "label": "Basel",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 15
  },
  {
    "unlocode": "IDSUB",
    "label": "Surabaya",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 15
  },
  {
    "unlocode": "TRISK",
    "label": "Iskenderun",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 15
  },
  {
    "unlocode": "TRMER",
    "label": "Mersin",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 15
  },
  {
    "unlocode": "BGBOJ",
    "label": "Burgas",
    "region": "Europe Med",
    "country": "Bulgaria",
    "score": 15
  },
  {
    "unlocode": "BDKAM",
    "label": "Icd Kamalapur, Dhaka",
    "region": "Middle East & ISC",
    "country": "Bangladesh",
    "score": 15
  },
  {
    "unlocode": "BDPGN",
    "label": "Pangaon",
    "region": "Middle East & ISC",
    "country": "Bangladesh",
    "score": 15
  },
  {
    "unlocode": "IEORK",
    "label": "Cork",
    "region": "Europe North",
    "country": "Ireland",
    "score": 14
  },
  {
    "unlocode": "INNAG",
    "label": "Nagpur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 14
  },
  {
    "unlocode": "JPNGO",
    "label": "Nagoya",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 14
  },
  {
    "unlocode": "VNBD1",
    "label": "Binh Duong",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 14
  },
  {
    "unlocode": "VNCLN",
    "label": "Cai Lan",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 14
  },
  {
    "unlocode": "PKLHE",
    "label": "Lahore",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 13
  },
  {
    "unlocode": "PKISB",
    "label": "Islamabad",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 13
  },
  {
    "unlocode": "PKLYP",
    "label": "Faisalabad",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 12
  },
  {
    "unlocode": "ZAELS",
    "label": "East London",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 11
  },
  {
    "unlocode": "GBLBK",
    "label": "Barking (London)",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 11
  },
  {
    "unlocode": "DEBRV",
    "label": "Bremerhaven",
    "region": "Europe North",
    "country": "Germany",
    "score": 10
  },
  {
    "unlocode": "EETLL",
    "label": "Tallinn",
    "region": "Europe North",
    "country": "Estonia",
    "score": 10
  },
  {
    "unlocode": "ITNAP",
    "label": "Napoli",
    "region": "Europe Med",
    "country": "Italy",
    "score": 10
  },
  {
    "unlocode": "ITPDA",
    "label": "Padova",
    "region": "Europe Med",
    "country": "Italy",
    "score": 10
  },
  {
    "unlocode": "DELUH",
    "label": "Ludwigshafen",
    "region": "Europe North",
    "country": "Germany",
    "score": 9
  },
  {
    "unlocode": "TRAMB",
    "label": "Ambarli",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 9
  },
  {
    "unlocode": "ITMZO",
    "label": "Melzo",
    "region": "Europe Med",
    "country": "Italy",
    "score": 9
  },
  {
    "unlocode": "DEBON",
    "label": "Bonn",
    "region": "Europe North",
    "country": "Germany",
    "score": 8
  },
  {
    "unlocode": "GBGLW",
    "label": "Glasgow",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 8
  },
  {
    "unlocode": "GBGRG",
    "label": "Grangemouth",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 8
  },
  {
    "unlocode": "ITSAL",
    "label": "Salerno",
    "region": "Europe Med",
    "country": "Italy",
    "score": 8
  },
  {
    "unlocode": "ITSPE",
    "label": "La Spezia",
    "region": "Europe Med",
    "country": "Italy",
    "score": 8
  },
  {
    "unlocode": "PLPK2",
    "label": "Pruskow",
    "region": "Europe North",
    "country": "Poland",
    "score": 8
  },
  {
    "unlocode": "USLAX",
    "label": "Los Angeles, CA",
    "region": "North America",
    "country": "United States",
    "score": 8
  },
  {
    "unlocode": "VNUIH",
    "label": "Qui Nhon",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 8
  },
  {
    "unlocode": "RUNOZ",
    "label": "Novokuznetsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 8
  },
  {
    "unlocode": "DEAND",
    "label": "Andernach",
    "region": "Europe North",
    "country": "Germany",
    "score": 8
  },
  {
    "unlocode": "ATWFT",
    "label": "Wolfurt",
    "region": "Europe North",
    "country": "Austria",
    "score": 7
  },
  {
    "unlocode": "DEFRA",
    "label": "Fscorefurt/Main",
    "region": "Europe North",
    "country": "Germany",
    "score": 7
  },
  {
    "unlocode": "MMRGN",
    "label": "Yangon",
    "region": "South East Asia",
    "country": "Myanmar",
    "score": 7
  },
  {
    "unlocode": "NOMSS",
    "label": "Moss",
    "region": "Europe North",
    "country": "Norway",
    "score": 7
  },
  {
    "unlocode": "UAODS",
    "label": "Odessa",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 7
  },
  {
    "unlocode": "PLWSW",
    "label": "Warszowice",
    "region": "Europe North",
    "country": "Poland",
    "score": 7
  },
  {
    "unlocode": "RUKHV",
    "label": "Khabarovsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 7
  },
  {
    "unlocode": "BRPNG",
    "label": "Paranagua",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 6
  },
  {
    "unlocode": "CZCTR",
    "label": "Ceska Trebova",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 6
  },
  {
    "unlocode": "DEBER",
    "label": "Berlin",
    "region": "Europe North",
    "country": "Germany",
    "score": 6
  },
  {
    "unlocode": "ESALG",
    "label": "Algeciras",
    "region": "Europe Med",
    "country": "Spain",
    "score": 6
  },
  {
    "unlocode": "ESSVQ",
    "label": "Sevilla",
    "region": "Europe Med",
    "country": "Spain",
    "score": 6
  },
  {
    "unlocode": "IDSRI",
    "label": "Samarinda",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 6
  },
  {
    "unlocode": "MYJHB",
    "label": "Johor Bahru",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 6
  },
  {
    "unlocode": "MYPEN",
    "label": "Penang",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 6
  },
  {
    "unlocode": "MYTPP",
    "label": "Tanjung Pelepas",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 6
  },
  {
    "unlocode": "USCHI",
    "label": "Chicago, IL",
    "region": "North America",
    "country": "United States",
    "score": 6
  },
  {
    "unlocode": "USLGB",
    "label": "Long Beach, CA",
    "region": "North America",
    "country": "United States",
    "score": 6
  },
  {
    "unlocode": "USTIW",
    "label": "Tacoma, WA",
    "region": "North America",
    "country": "United States",
    "score": 6
  },
  {
    "unlocode": "BRSSZ",
    "label": "Santos",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 5
  },
  {
    "unlocode": "EGADA",
    "label": "Adabiya",
    "region": "North Africa",
    "country": "Egypt",
    "score": 5
  },
  {
    "unlocode": "ESBIO",
    "label": "Bilbao",
    "region": "Europe Med",
    "country": "Spain",
    "score": 5
  },
  {
    "unlocode": "GBLGP",
    "label": "London Gateway Port, Ess",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 5
  },
  {
    "unlocode": "LVRIX",
    "label": "Riga",
    "region": "Europe North",
    "country": "Latvia",
    "score": 5
  },
  {
    "unlocode": "PTLEI",
    "label": "Leixoes",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 5
  },
  {
    "unlocode": "USDAL",
    "label": "Dallas, TX",
    "region": "North America",
    "country": "United States",
    "score": 5
  },
  {
    "unlocode": "USHOU",
    "label": "Houston, TX",
    "region": "North America",
    "country": "United States",
    "score": 5
  },
  {
    "unlocode": "ZAPLZ",
    "label": "Port Elizabeth",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 5
  },
  {
    "unlocode": "DECGN",
    "label": "Cologne",
    "region": "Europe North",
    "country": "Germany",
    "score": 4
  },
  {
    "unlocode": "DELEJ",
    "label": "Leipzig",
    "region": "Europe North",
    "country": "Germany",
    "score": 4
  },
  {
    "unlocode": "DESTR",
    "label": "Stuttgart",
    "region": "Europe North",
    "country": "Germany",
    "score": 4
  },
  {
    "unlocode": "DEULM",
    "label": "Ulm",
    "region": "Europe North",
    "country": "Germany",
    "score": 4
  },
  {
    "unlocode": "DEVRD",
    "label": "Voerde",
    "region": "Europe North",
    "country": "Germany",
    "score": 4
  },
  {
    "unlocode": "ITVCE",
    "label": "Venezia",
    "region": "Europe Med",
    "country": "Italy",
    "score": 4
  },
  {
    "unlocode": "JPTYO",
    "label": "Tokyo",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 4
  },
  {
    "unlocode": "JPUKB",
    "label": "Kobe",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 4
  },
  {
    "unlocode": "PLBZD",
    "label": "Brzeg Dolny",
    "region": "Europe North",
    "country": "Poland",
    "score": 4
  },
  {
    "unlocode": "TRGEB",
    "label": "Gebze",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 4
  },
  {
    "unlocode": "TRHAY",
    "label": "Haydarpasa Istanbul Asian Side",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 4
  },
  {
    "unlocode": "USCBF",
    "label": "Council Bluffs, IA",
    "region": "North America",
    "country": "United States",
    "score": 4
  },
  {
    "unlocode": "USPDX",
    "label": "Portland, OR",
    "region": "North America",
    "country": "United States",
    "score": 4
  },
  {
    "unlocode": "USSEA",
    "label": "Seattle, WA",
    "region": "North America",
    "country": "United States",
    "score": 4
  },
  {
    "unlocode": "AUMEL",
    "label": "Melbourne",
    "region": "Oceania",
    "country": "Australia",
    "score": 3
  },
  {
    "unlocode": "DEDTM",
    "label": "Dortmund",
    "region": "Europe North",
    "country": "Germany",
    "score": 3
  },
  {
    "unlocode": "DEMAI",
    "label": "Mainz",
    "region": "Europe North",
    "country": "Germany",
    "score": 3
  },
  {
    "unlocode": "EGALY",
    "label": "Alexandria",
    "region": "North Africa",
    "country": "Egypt",
    "score": 3
  },
  {
    "unlocode": "GBBHM",
    "label": "Birmingham",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 3
  },
  {
    "unlocode": "GBDON",
    "label": "Doncaster",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 3
  },
  {
    "unlocode": "GBLBA",
    "label": "Leeds",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 3
  },
  {
    "unlocode": "IDBLW",
    "label": "Belawan",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 3
  },
  {
    "unlocode": "IDPNJ",
    "label": "Panjang",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 3
  },
  {
    "unlocode": "ITRIV",
    "label": "Rivalta Scrivia",
    "region": "Europe Med",
    "country": "Italy",
    "score": 3
  },
  {
    "unlocode": "ITVRN",
    "label": "Verona",
    "region": "Europe Med",
    "country": "Italy",
    "score": 3
  },
  {
    "unlocode": "MACAS",
    "label": "Casablanca",
    "region": "North Africa",
    "country": "Morocco",
    "score": 3
  },
  {
    "unlocode": "NLTLB",
    "label": "Tilburg",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 3
  },
  {
    "unlocode": "NZAKL",
    "label": "Auckland",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 3
  },
  {
    "unlocode": "PECLL",
    "label": "Callao",
    "region": "Latin America West",
    "country": "Peru",
    "score": 3
  },
  {
    "unlocode": "PLKYW",
    "label": "Katy Wroclawskie",
    "region": "Europe North",
    "country": "Poland",
    "score": 3
  },
  {
    "unlocode": "PLWRO",
    "label": "Wroclaw",
    "region": "Europe North",
    "country": "Poland",
    "score": 3
  },
  {
    "unlocode": "RUCEK",
    "label": "Chelyabinsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 3
  },
  {
    "unlocode": "RUKZN",
    "label": "Kazan",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 3
  },
  {
    "unlocode": "RUOMS",
    "label": "Omsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 3
  },
  {
    "unlocode": "SKDJA",
    "label": "Dunajske Streda",
    "region": "Europe Med",
    "country": "Slovakia",
    "score": 3
  },
  {
    "unlocode": "UAIEV",
    "label": "Kiev",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 3
  },
  {
    "unlocode": "USNYC",
    "label": "New York, NY",
    "region": "North America",
    "country": "United States",
    "score": 3
  },
  {
    "unlocode": "ZACPT",
    "label": "Cape Town",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 3
  },
  {
    "unlocode": "PLPOZ",
    "label": "Poznan",
    "region": "Europe North",
    "country": "Poland",
    "score": 3
  },
  {
    "unlocode": "RUGOJ",
    "label": "Nizhniy Novgorod",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 3
  },
  {
    "unlocode": "AEAJM",
    "label": "Ajman",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 2
  },
  {
    "unlocode": "BEAAT",
    "label": "Athus",
    "region": "Europe North",
    "country": "Belgium",
    "score": 2
  },
  {
    "unlocode": "DEBRE",
    "label": "Bremen",
    "region": "Europe North",
    "country": "Germany",
    "score": 2
  },
  {
    "unlocode": "DEBWE",
    "label": "Braunschweig",
    "region": "Europe North",
    "country": "Germany",
    "score": 2
  },
  {
    "unlocode": "DEKOR",
    "label": "Kornwestheim",
    "region": "Europe North",
    "country": "Germany",
    "score": 2
  },
  {
    "unlocode": "DEWVN",
    "label": "Wilhelmshaven",
    "region": "Europe North",
    "country": "Germany",
    "score": 2
  },
  {
    "unlocode": "EEPLA",
    "label": "Paldiski",
    "region": "Europe North",
    "country": "Estonia",
    "score": 2
  },
  {
    "unlocode": "ESCAS",
    "label": "Castellon De La Plana",
    "region": "Europe Med",
    "country": "Spain",
    "score": 2
  },
  {
    "unlocode": "GBBEL",
    "label": "Belfast (United Kingdom)",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 2
  },
  {
    "unlocode": "GBTEE",
    "label": "Teesport",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 2
  },
  {
    "unlocode": "GBTHP",
    "label": "Thames Port",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 2
  },
  {
    "unlocode": "MXATM",
    "label": "Altamira",
    "region": "North America",
    "country": "Mexico",
    "score": 2
  },
  {
    "unlocode": "NGLOS",
    "label": "Lagos",
    "region": "West Africa",
    "country": "Nigeria",
    "score": 2
  },
  {
    "unlocode": "OMSOH",
    "label": "Sohar",
    "region": "Middle East & ISC",
    "country": "Oman",
    "score": 2
  },
  {
    "unlocode": "PLGI8",
    "label": "Gadki",
    "region": "Europe North",
    "country": "Poland",
    "score": 2
  },
  {
    "unlocode": "PTLIS",
    "label": "Lisboa",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 2
  },
  {
    "unlocode": "SAJED",
    "label": "Jeddah",
    "region": "Middle East & ISC",
    "country": "Saudi Arabia",
    "score": 2
  },
  {
    "unlocode": "SEHAD",
    "label": "Halmstad",
    "region": "Europe North",
    "country": "Sweden",
    "score": 2
  },
  {
    "unlocode": "SEHEL",
    "label": "Helsingborg",
    "region": "Europe North",
    "country": "Sweden",
    "score": 2
  },
  {
    "unlocode": "THLKR",
    "label": "Lat Krabang",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 2
  },
  {
    "unlocode": "USCHS",
    "label": "Charleston, SC",
    "region": "North America",
    "country": "United States",
    "score": 2
  },
  {
    "unlocode": "USCLE",
    "label": "Cleveland, OH",
    "region": "North America",
    "country": "United States",
    "score": 2
  },
  {
    "unlocode": "USMES",
    "label": "Minneapolis, MN",
    "region": "North America",
    "country": "United States",
    "score": 2
  },
  {
    "unlocode": "USMIA",
    "label": "Miami, FL",
    "region": "North America",
    "country": "United States",
    "score": 2
  },
  {
    "unlocode": "DEEMM",
    "label": "Emmerich",
    "region": "Europe North",
    "country": "Germany",
    "score": 2
  },
  {
    "unlocode": "INVIZ",
    "label": "Vizag",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 2
  },
  {
    "unlocode": "QAHMD",
    "label": "Hamad",
    "region": "Middle East & ISC",
    "country": "Qatar",
    "score": 2
  },
  {
    "unlocode": "ITROM",
    "label": "Rome (Roma)",
    "region": "Europe Med",
    "country": "Italy",
    "score": 2
  },
  {
    "unlocode": "AEAUH",
    "label": "Abu Dhabi",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 1
  },
  {
    "unlocode": "AEFJR",
    "label": "Fujairah",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 1
  },
  {
    "unlocode": "ATENA",
    "label": "Enns",
    "region": "Europe North",
    "country": "Austria",
    "score": 1
  },
  {
    "unlocode": "BEZEE",
    "label": "Zeebrugge",
    "region": "Europe North",
    "country": "Belgium",
    "score": 1
  },
  {
    "unlocode": "BRITJ",
    "label": "Itajai",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 1
  },
  {
    "unlocode": "BRNVT",
    "label": "Navegantes",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 1
  },
  {
    "unlocode": "BRRIO",
    "label": "Rio De Janeiro",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 1
  },
  {
    "unlocode": "CAVAN",
    "label": "Vancouver, BC",
    "region": "North America",
    "country": "Canada",
    "score": 1
  },
  {
    "unlocode": "CLSAI",
    "label": "San Antonio",
    "region": "Latin America West",
    "country": "Chile",
    "score": 1
  },
  {
    "unlocode": "DEBFE",
    "label": "Bielefeld",
    "region": "Europe North",
    "country": "Germany",
    "score": 1
  },
  {
    "unlocode": "DEMHG",
    "label": "Mannheim",
    "region": "Europe North",
    "country": "Germany",
    "score": 1
  },
  {
    "unlocode": "DENSS",
    "label": "Neuss",
    "region": "Europe North",
    "country": "Germany",
    "score": 1
  },
  {
    "unlocode": "DKCPH",
    "label": "Copenhagen",
    "region": "Europe North",
    "country": "Denmark",
    "score": 1
  },
  {
    "unlocode": "ESMAD",
    "label": "Madrid",
    "region": "Europe Med",
    "country": "Spain",
    "score": 1
  },
  {
    "unlocode": "GBLIV",
    "label": "Liverpool",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 1
  },
  {
    "unlocode": "GBMNC",
    "label": "Manchester",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 1
  },
  {
    "unlocode": "INCOK",
    "label": "Cochin",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 1
  },
  {
    "unlocode": "INVTZ",
    "label": "Visakhapatnam",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 1
  },
  {
    "unlocode": "ITBLQ",
    "label": "Bologna",
    "region": "Europe Med",
    "country": "Italy",
    "score": 1
  },
  {
    "unlocode": "ITLIV",
    "label": "Livorno",
    "region": "Europe Med",
    "country": "Italy",
    "score": 1
  },
  {
    "unlocode": "JPOSA",
    "label": "Osaka",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 1
  },
  {
    "unlocode": "JPYOK",
    "label": "Yokohama",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 1
  },
  {
    "unlocode": "KZKOV",
    "label": "Kokchetau",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 1
  },
  {
    "unlocode": "KZKSN",
    "label": "Kostanay",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 1
  },
  {
    "unlocode": "MAPTM",
    "label": "Tanger Med",
    "region": "North Africa",
    "country": "Morocco",
    "score": 1
  },
  {
    "unlocode": "MYPGU",
    "label": "Pasir Gudang",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 1
  },
  {
    "unlocode": "NZNPE",
    "label": "Napier",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 1
  },
  {
    "unlocode": "PLDAB",
    "label": "Dabrowa Gornicza",
    "region": "Europe North",
    "country": "Poland",
    "score": 1
  },
  {
    "unlocode": "SADMM",
    "label": "Dammam",
    "region": "Middle East & ISC",
    "country": "Saudi Arabia",
    "score": 1
  },
  {
    "unlocode": "SAJUB",
    "label": "Jubail",
    "region": "Middle East & ISC",
    "country": "Saudi Arabia",
    "score": 1
  },
  {
    "unlocode": "SEGOT",
    "label": "Gothenburg",
    "region": "Europe North",
    "country": "Sweden",
    "score": 1
  },
  {
    "unlocode": "TRASR",
    "label": "Kayseri",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 1
  },
  {
    "unlocode": "TRGEM",
    "label": "Gemlik",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 1
  },
  {
    "unlocode": "TRIZT",
    "label": "Izmit",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 1
  },
  {
    "unlocode": "USOAK",
    "label": "Oakland, CA",
    "region": "North America",
    "country": "United States",
    "score": 1
  },
  {
    "unlocode": "USSAV",
    "label": "Savannah, GA",
    "region": "North America",
    "country": "United States",
    "score": 1
  },
  {
    "unlocode": "ZADUR",
    "label": "Durban",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 1
  },
  {
    "unlocode": "ZARCB",
    "label": "Richards Bay",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 1
  },
  {
    "unlocode": "PLGWC",
    "label": "Gliwice (Poland)",
    "region": "Europe North",
    "country": "Poland",
    "score": 1
  },
  {
    "unlocode": "KRINC",
    "label": "Incheon",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 1
  },
  {
    "unlocode": "DEDUS",
    "label": "Duesseldorf",
    "region": "Europe North",
    "country": "Germany",
    "score": 1
  },
  {
    "unlocode": "DEKEH",
    "label": "Kehl",
    "region": "Europe North",
    "country": "Germany",
    "score": 1
  },
  {
    "unlocode": "PLKTW",
    "label": "Katowice",
    "region": "Europe North",
    "country": "Poland",
    "score": 1
  },
  {
    "unlocode": "RUNZK",
    "label": "Nizhnekamsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 1
  },
  {
    "unlocode": "ITSVN",
    "label": "Savona",
    "region": "Europe Med",
    "country": "Italy",
    "score": 1
  },
  {
    "unlocode": "AEKHL",
    "label": "Khalifa Port, Abu Dhabi",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 0
  },
  {
    "unlocode": "AEKLF",
    "label": "Khor Fakkan",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 0
  },
  {
    "unlocode": "AEQIW",
    "label": "Umm Al Qaiwain",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 0
  },
  {
    "unlocode": "AERKT",
    "label": "Ras Al Khaimah",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 0
  },
  {
    "unlocode": "AESHJ",
    "label": "Sharjah",
    "region": "Middle East & ISC",
    "country": "United Arab Emirates",
    "score": 0
  },
  {
    "unlocode": "AGSJO",
    "label": "St John's",
    "region": "Central America & Carribean",
    "country": "Antigua And Barbuda",
    "score": 0
  },
  {
    "unlocode": "AIRBY",
    "label": "Road Bay",
    "region": "Central America & Carribean",
    "country": "Anguilla",
    "score": 0
  },
  {
    "unlocode": "ALDRZ",
    "label": "Durres",
    "region": "Europe Med",
    "country": "Albania",
    "score": 0
  },
  {
    "unlocode": "AMEVN",
    "label": "Yerevan",
    "region": "Europe Med",
    "country": "Armenia",
    "score": 0
  },
  {
    "unlocode": "ANKRA",
    "label": "Kralendijk, Bonaire",
    "region": "Central America & Carribean",
    "country": "Netherlands Antilles",
    "score": 0
  },
  {
    "unlocode": "ANPHI",
    "label": "Philipsburg",
    "region": "Central America & Carribean",
    "country": "Netherlands Antilles",
    "score": 0
  },
  {
    "unlocode": "ANSAB",
    "label": "Fort Bay, Saba",
    "region": "Central America & Carribean",
    "country": "Netherlands Antilles",
    "score": 0
  },
  {
    "unlocode": "ANWIL",
    "label": "Willemstad",
    "region": "Central America & Carribean",
    "country": "Netherlands Antilles",
    "score": 0
  },
  {
    "unlocode": "AN8OJ",
    "label": "Oranjestad",
    "region": "Central America & Carribean",
    "country": "Netherlands Antilles",
    "score": 0
  },
  {
    "unlocode": "AOCAB",
    "label": "Cabinda",
    "region": "Southern Africa",
    "country": "Angola",
    "score": 0
  },
  {
    "unlocode": "AOLAD",
    "label": "Luanda",
    "region": "Southern Africa",
    "country": "Angola",
    "score": 0
  },
  {
    "unlocode": "AOLOB",
    "label": "Lobito",
    "region": "Southern Africa",
    "country": "Angola",
    "score": 0
  },
  {
    "unlocode": "AOMSZ",
    "label": "Namibe",
    "region": "Southern Africa",
    "country": "Angola",
    "score": 0
  },
  {
    "unlocode": "AOSOQ",
    "label": "Soyo-Quinfuquena Terminal",
    "region": "Southern Africa",
    "country": "Angola",
    "score": 0
  },
  {
    "unlocode": "ARBHI",
    "label": "Bahia Blanca",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARBUE",
    "label": "Buenos Aires",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARMDZ",
    "label": "Mendoza",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARROS",
    "label": "Rosario",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARSFN",
    "label": "Santa Fe",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARUSH",
    "label": "Ushuaia",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARZAE",
    "label": "Zarate",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ATGRZ",
    "label": "Graz",
    "region": "Europe North",
    "country": "Austria",
    "score": 0
  },
  {
    "unlocode": "ATKRE",
    "label": "Krems",
    "region": "Europe North",
    "country": "Austria",
    "score": 0
  },
  {
    "unlocode": "AUADL",
    "label": "Adelaide",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUBEL",
    "label": "Bell Bay",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUBNE",
    "label": "Brisbane",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUBWT",
    "label": "Burnie",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUCNS",
    "label": "Cairns",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUDPO",
    "label": "Devonport",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUDRW",
    "label": "Darwin",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUEPR",
    "label": "Esperance",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUFRE",
    "label": "Fremantle",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUGFF",
    "label": "Griffith",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUHBA",
    "label": "Hobart",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AULST",
    "label": "Launceston",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUMKY",
    "label": "Mackay",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUNTL",
    "label": "Newcastle",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUPKL",
    "label": "Port Kembla",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUPTL",
    "label": "Port Alma",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUROK",
    "label": "Rockhampton",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUSYD",
    "label": "Sydney",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUTSV",
    "label": "Townsville",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AUTWB",
    "label": "Toowoomba",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "AWORJ",
    "label": "Oranjestad (Aruba)",
    "region": "Central America & Carribean",
    "country": "Aruba",
    "score": 0
  },
  {
    "unlocode": "AZBAK",
    "label": "Baku",
    "region": "Europe Med",
    "country": "Azerbaijan",
    "score": 0
  },
  {
    "unlocode": "BBBGI",
    "label": "Bridgetown",
    "region": "Central America & Carribean",
    "country": "Barbados",
    "score": 0
  },
  {
    "unlocode": "BEANB",
    "label": "Angleur",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "BEGBB",
    "label": "Grobbendonk",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "BEGNK",
    "label": "Genk",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "BEMEH",
    "label": "Meerhout",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "BEMOS",
    "label": "Moeskroen",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "BEWLB",
    "label": "Willebroek",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "BFBNR",
    "label": "Banfora",
    "region": "West Africa",
    "country": "Burkina Faso",
    "score": 0
  },
  {
    "unlocode": "BFBOY",
    "label": "Bobo Dioulasso",
    "region": "West Africa",
    "country": "Burkina Faso",
    "score": 0
  },
  {
    "unlocode": "BFFNG",
    "label": "Fada-Ngourma",
    "region": "West Africa",
    "country": "Burkina Faso",
    "score": 0
  },
  {
    "unlocode": "BFKOU",
    "label": "Koudougou",
    "region": "West Africa",
    "country": "Burkina Faso",
    "score": 0
  },
  {
    "unlocode": "BFOUA",
    "label": "Ouagadougou",
    "region": "West Africa",
    "country": "Burkina Faso",
    "score": 0
  },
  {
    "unlocode": "BHBAH",
    "label": "Bahrain",
    "region": "Middle East & ISC",
    "country": "Bahrain",
    "score": 0
  },
  {
    "unlocode": "BHKBS",
    "label": "Bahrain Khalifa Bin Salman Port",
    "region": "Middle East & ISC",
    "country": "Bahrain",
    "score": 0
  },
  {
    "unlocode": "BIBJM",
    "label": "Bujumbura",
    "region": "East Africa",
    "country": "Burundi",
    "score": 0
  },
  {
    "unlocode": "BINGZ",
    "label": "Ngozi",
    "region": "East Africa",
    "country": "Burundi",
    "score": 0
  },
  {
    "unlocode": "BJCOO",
    "label": "Cotonou",
    "region": "West Africa",
    "country": "Benin",
    "score": 0
  },
  {
    "unlocode": "BNMUA",
    "label": "Muara",
    "region": "South East Asia",
    "country": "Brunei Darussalam",
    "score": 0
  },
  {
    "unlocode": "BOCBB",
    "label": "Cochabamba",
    "region": "Latin America West",
    "country": "Bolivia",
    "score": 0
  },
  {
    "unlocode": "BOLPB",
    "label": "La Paz",
    "region": "Latin America West",
    "country": "Bolivia",
    "score": 0
  },
  {
    "unlocode": "BOORU",
    "label": "Oruro",
    "region": "Latin America West",
    "country": "Bolivia",
    "score": 0
  },
  {
    "unlocode": "BOSRZ",
    "label": "Santa Cruz",
    "region": "Latin America West",
    "country": "Bolivia",
    "score": 0
  },
  {
    "unlocode": "BRBEL",
    "label": "Belem",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRCA4",
    "label": "Cambe, PR",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRCWB",
    "label": "Curitiba",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRETO",
    "label": "Esteio",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRFOR",
    "label": "Fortaleza",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRIBB",
    "label": "Imbituba",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRIGI",
    "label": "Itaguai, RJ",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRIOA",
    "label": "Itapoa, SC",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRIQI",
    "label": "Itaqui, MA",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRMAO",
    "label": "Manaus",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRMCP",
    "label": "Macapa",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRNAT",
    "label": "Natal",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRPEC",
    "label": "Pecem",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRPGZ",
    "label": "Ponta Grossa",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRPVH",
    "label": "Porto Velho",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRQSB",
    "label": "Sao Bernardo Do Campo",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRREC",
    "label": "Recife",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRRIG",
    "label": "Rio Grande",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRSAN",
    "label": "Santana",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRSFS",
    "label": "Sao Francisco Do Sul",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRSSA",
    "label": "Salvador Di Bahia",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRSTM",
    "label": "Santarem",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRSUA",
    "label": "Suape",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRVCO",
    "label": "Vila Do Conde",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRVIX",
    "label": "Vitoria (Brazil)",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BSFPO",
    "label": "Freeport Grand Bahama",
    "region": "Central America & Carribean",
    "country": "Bahamas",
    "score": 0
  },
  {
    "unlocode": "BWGBE",
    "label": "Gaborone",
    "region": "Southern Africa",
    "country": "Botswana",
    "score": 0
  },
  {
    "unlocode": "BZBGK",
    "label": "Big Creek",
    "region": "Central America & Carribean",
    "country": "Belize",
    "score": 0
  },
  {
    "unlocode": "BZBZE",
    "label": "Belize City",
    "region": "Central America & Carribean",
    "country": "Belize",
    "score": 0
  },
  {
    "unlocode": "CABI4",
    "label": "Blue River, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CABOU",
    "label": "Boucherville, QC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CABRM",
    "label": "Bramalea, ON",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CABRP",
    "label": "Brampton, ON",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CACAL",
    "label": "Calgary, AB",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CACOQ",
    "label": "Coquitlam, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAEDM",
    "label": "Edmonton, AB",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAEE6",
    "label": "Emerson, MB",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAETC",
    "label": "Etobicoke, ON",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAFE7",
    "label": "Foleyet, ON",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAHAL",
    "label": "Halifax, NS",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAHDN",
    "label": "Huntingdon, QC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAJPR",
    "label": "Jasper, AB",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CALAC",
    "label": "Lachine/Montreal, QC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CALAS",
    "label": "Lasalle (La Salle), QC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAMNT",
    "label": "Moncton, NB",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CARBC",
    "label": "Richmond, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAREG",
    "label": "Regina, SK",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CARIC",
    "label": "Richelieu, QC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CASAK",
    "label": "Saskatoon, SK",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CASJF",
    "label": "Saint-John'S, NL",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CASUY",
    "label": "Surrey, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CATA8",
    "label": "Transcona, MB",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CATHU",
    "label": "Thunder Bay, ON",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAWNP",
    "label": "Winnipeg, MB",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAYMJ",
    "label": "Moose Jaw, SK",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAYXR",
    "label": "Earlton, ON",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CA1AK",
    "label": "Roberts Bank, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CDBKY",
    "label": "Bukavu",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDBNW",
    "label": "Banana",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDBOA",
    "label": "Boma",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDFBM",
    "label": "Lubumbashi",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDFIH",
    "label": "Kinshasa",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDGOM",
    "label": "Goma",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDKWZ",
    "label": "Kolwezi",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDLS1",
    "label": "Likasi",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CDMAT",
    "label": "Matadi",
    "region": "East Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CFBGF",
    "label": "Bangui",
    "region": "East Africa",
    "country": "Central African Republic",
    "score": 0
  },
  {
    "unlocode": "CFBOP",
    "label": "Bouar",
    "region": "East Africa",
    "country": "Central African Republic",
    "score": 0
  },
  {
    "unlocode": "CGBZV",
    "label": "Brazzaville",
    "region": "West Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CGPNR",
    "label": "Pointe Noire",
    "region": "West Africa",
    "country": "Congo",
    "score": 0
  },
  {
    "unlocode": "CHBFL",
    "label": "Birsfelden/Basel",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 0
  },
  {
    "unlocode": "CHCVY",
    "label": "Chavornay",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 0
  },
  {
    "unlocode": "CHFKD",
    "label": "Frenkendorf",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 0
  },
  {
    "unlocode": "CHGVA",
    "label": "Geneve",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 0
  },
  {
    "unlocode": "CHME1",
    "label": "Mellikon, AG",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 0
  },
  {
    "unlocode": "CIABJ",
    "label": "Abidjan",
    "region": "West Africa",
    "country": "Côte D'Ivoire",
    "score": 0
  },
  {
    "unlocode": "CIBYK",
    "label": "Bouake",
    "region": "West Africa",
    "country": "Côte D'Ivoire",
    "score": 0
  },
  {
    "unlocode": "CISPY",
    "label": "San Pedro (Cote D'Ivoire)",
    "region": "West Africa",
    "country": "Côte D'Ivoire",
    "score": 0
  },
  {
    "unlocode": "CLANF",
    "label": "Antofagasta",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLARI",
    "label": "Arica",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLCNL",
    "label": "Coronel",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLCQQ",
    "label": "Coquimbo",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLIQQ",
    "label": "Iquique",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLLQN",
    "label": "Lirquen",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLPAG",
    "label": "Puerto Angamos, AN",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLPMC",
    "label": "Puerto Montt",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLPUQ",
    "label": "Punta Arenas",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLSCL",
    "label": "Santiago",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLSVE",
    "label": "San Vicente",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLTAL",
    "label": "Talcahuano",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CLVAP",
    "label": "Valparaiso",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "CMBEL",
    "label": "Belabo",
    "region": "West Africa",
    "country": "Cameroon",
    "score": 0
  },
  {
    "unlocode": "CMDLA",
    "label": "Douala",
    "region": "West Africa",
    "country": "Cameroon",
    "score": 0
  },
  {
    "unlocode": "CMGOU",
    "label": "Garoua",
    "region": "West Africa",
    "country": "Cameroon",
    "score": 0
  },
  {
    "unlocode": "CMNGE",
    "label": "Ngaoundere",
    "region": "West Africa",
    "country": "Cameroon",
    "score": 0
  },
  {
    "unlocode": "COBAQ",
    "label": "Barranquilla",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "COBOG",
    "label": "Bogota",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "COBUN",
    "label": "Buenaventura",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "COCLO",
    "label": "Cali",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "COCTG",
    "label": "Cartagena (Colombia)",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "COMDE",
    "label": "Medellin",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "COSMR",
    "label": "Santa Marta",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "COTRB",
    "label": "Turbo",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "CRCAL",
    "label": "Puerto Caldera",
    "region": "Central America & Carribean",
    "country": "Costa Rica",
    "score": 0
  },
  {
    "unlocode": "CRLIO",
    "label": "Puerto Limon",
    "region": "Central America & Carribean",
    "country": "Costa Rica",
    "score": 0
  },
  {
    "unlocode": "CRMOB",
    "label": "Moin, L",
    "region": "Central America & Carribean",
    "country": "Costa Rica",
    "score": 0
  },
  {
    "unlocode": "CRSJO",
    "label": "San Jose",
    "region": "Central America & Carribean",
    "country": "Costa Rica",
    "score": 0
  },
  {
    "unlocode": "CUHAV",
    "label": "Havana",
    "region": "Central America & Carribean",
    "country": "Cuba",
    "score": 0
  },
  {
    "unlocode": "CUMAR",
    "label": "Mariel",
    "region": "Central America & Carribean",
    "country": "Cuba",
    "score": 0
  },
  {
    "unlocode": "CUMZO",
    "label": "Manzanillo (Cuba)",
    "region": "Central America & Carribean",
    "country": "Cuba",
    "score": 0
  },
  {
    "unlocode": "CUSCU",
    "label": "Santiago De Cuba",
    "region": "Central America & Carribean",
    "country": "Cuba",
    "score": 0
  },
  {
    "unlocode": "CVMIN",
    "label": "Mindelo",
    "region": "West Africa",
    "country": "Cape Verde",
    "score": 0
  },
  {
    "unlocode": "CVRAI",
    "label": "Praia",
    "region": "West Africa",
    "country": "Cape Verde",
    "score": 0
  },
  {
    "unlocode": "CYFMG",
    "label": "Famagusta",
    "region": "Europe Med",
    "country": "Cyprus",
    "score": 0
  },
  {
    "unlocode": "CYLCA",
    "label": "Larnaca",
    "region": "Europe Med",
    "country": "Cyprus",
    "score": 0
  },
  {
    "unlocode": "CYLMS",
    "label": "Limassol",
    "region": "Europe Med",
    "country": "Cyprus",
    "score": 0
  },
  {
    "unlocode": "CZPLZ",
    "label": "Plzen",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "CZPSV",
    "label": "Paskov",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "CZZLN",
    "label": "Zlin",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "DEAGB",
    "label": "Augsburg",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEBHN",
    "label": "Burghausen",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEFSG",
    "label": "Fussgonheim, RP",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEGER",
    "label": "Germersheim",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEHOQ",
    "label": "Hof",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEKAE",
    "label": "Karlsruhe",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEKEL",
    "label": "Kiel",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEKOB",
    "label": "Koblenz",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEWEA",
    "label": "Wiesau, BY",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEWOE",
    "label": "Worth Am Rhein",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEWOR",
    "label": "Worms",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DJJIB",
    "label": "Djibouti",
    "region": "East Africa",
    "country": "Djibouti",
    "score": 0
  },
  {
    "unlocode": "DKAAL",
    "label": "Aalborg",
    "region": "Europe North",
    "country": "Denmark",
    "score": 0
  },
  {
    "unlocode": "DKEBJ",
    "label": "Esbjerg",
    "region": "Europe North",
    "country": "Denmark",
    "score": 0
  },
  {
    "unlocode": "DKKAL",
    "label": "Kalundborg",
    "region": "Europe North",
    "country": "Denmark",
    "score": 0
  },
  {
    "unlocode": "DKODE",
    "label": "Odense",
    "region": "Europe North",
    "country": "Denmark",
    "score": 0
  },
  {
    "unlocode": "DMBEL",
    "label": "Belfast (Dominica)",
    "region": "Central America & Carribean",
    "country": "Dominica",
    "score": 0
  },
  {
    "unlocode": "DMRSU",
    "label": "Roseau",
    "region": "Central America & Carribean",
    "country": "Dominica",
    "score": 0
  },
  {
    "unlocode": "DOCAU",
    "label": "Caucedo",
    "region": "Central America & Carribean",
    "country": "Dominican Republic",
    "score": 0
  },
  {
    "unlocode": "DOHAI",
    "label": "Rio Haina",
    "region": "Central America & Carribean",
    "country": "Dominican Republic",
    "score": 0
  },
  {
    "unlocode": "DOMAN",
    "label": "Manzanillo (Dominican Republic)",
    "region": "Central America & Carribean",
    "country": "Dominican Republic",
    "score": 0
  },
  {
    "unlocode": "DZAAE",
    "label": "Annaba",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZALG",
    "label": "Alger",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZAZW",
    "label": "Arzew",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZBJA",
    "label": "Bejaia",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZDJE",
    "label": "Djen Djen",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZGHZ",
    "label": "Ghazaouet",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZMOS",
    "label": "Mostaganem",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZORN",
    "label": "Oran",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "DZSKI",
    "label": "Skikda",
    "region": "North Africa",
    "country": "Algeria",
    "score": 0
  },
  {
    "unlocode": "ECGYE",
    "label": "Guayaquil",
    "region": "Latin America West",
    "country": "Ecuador",
    "score": 0
  },
  {
    "unlocode": "ECLLD",
    "label": "La Libertad",
    "region": "Latin America West",
    "country": "Ecuador",
    "score": 0
  },
  {
    "unlocode": "ECUIO",
    "label": "Quito",
    "region": "Latin America West",
    "country": "Ecuador",
    "score": 0
  },
  {
    "unlocode": "EGAIS",
    "label": "Ain Sukhna",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGCAI",
    "label": "Cairo",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGDAM",
    "label": "Damietta",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGPSD",
    "label": "Port Said",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGPSE",
    "label": "Port Said East",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGSOS",
    "label": "6Th October",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGSUZ",
    "label": "Port Said, Suez Canal Cntr Term",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGTRC",
    "label": "10Th Of Ramadan City",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "ESACE",
    "label": "Arrecife De Lanzarote",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESAGP",
    "label": "Malaga",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESALC",
    "label": "Alicante",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESBUR",
    "label": "Burgos",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESCAD",
    "label": "Cadiz",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESCEU",
    "label": "Ceuta",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESCTA",
    "label": "Cantoria",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESFUE",
    "label": "Puerto Del Rosario-Fuerteventura",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESGAN",
    "label": "Gandia",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESGIJ",
    "label": "Gijon",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESHUV",
    "label": "Huelva",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESIBZ",
    "label": "Ibiza",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESLCG",
    "label": "La Coruna",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESLEI",
    "label": "Almeria",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESLEN",
    "label": "Leon",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESLLE",
    "label": "Lleida",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESLPA",
    "label": "Las Palmas",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESMJV",
    "label": "Murcia",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESMLN",
    "label": "Melilla",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESMNZ",
    "label": "Monzon",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESMPG",
    "label": "Marin, Pontevedra",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESSCT",
    "label": "Santa Cruz De Tenerife",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESSDR",
    "label": "Santander",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESSPC",
    "label": "Santa Cruz De La Palma",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESVGO",
    "label": "Vigo",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESVIT",
    "label": "Vitoria (Spain)",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESVLL",
    "label": "Valladolid",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ESZAZ",
    "label": "Zaragoza",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "ETADD",
    "label": "Addis Ababa",
    "region": "East Africa",
    "country": "Ethiopia",
    "score": 0
  },
  {
    "unlocode": "FIHMN",
    "label": "Hamina (Fredrikshamn)",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FIKEM",
    "label": "Kemi",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FIKTK",
    "label": "Kotka",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FIMTL",
    "label": "Mantyluoto",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FINJI",
    "label": "Nurmijarvi, ES",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FIRAU",
    "label": "Rauma",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FITOR",
    "label": "Tornio",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FJLTK",
    "label": "Lautoka",
    "region": "Oceania",
    "country": "Fiji",
    "score": 0
  },
  {
    "unlocode": "FJSUV",
    "label": "Suva",
    "region": "Oceania",
    "country": "Fiji",
    "score": 0
  },
  {
    "unlocode": "FOTHO",
    "label": "Thorshavn",
    "region": "Europe North",
    "country": "Faroe Islands",
    "score": 0
  },
  {
    "unlocode": "GALBV",
    "label": "Libreville",
    "region": "West Africa",
    "country": "Gabon",
    "score": 0
  },
  {
    "unlocode": "GAPOG",
    "label": "Port Gentil",
    "region": "West Africa",
    "country": "Gabon",
    "score": 0
  },
  {
    "unlocode": "GBABD",
    "label": "Aberdeen",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBBKG",
    "label": "Barking",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBBOE",
    "label": "Bootle",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBBRS",
    "label": "Bristol",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBCDF",
    "label": "Cardiff",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBCNK",
    "label": "Cannock",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBCOT",
    "label": "Coatbridge",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBDVR",
    "label": "Dover",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBDVY",
    "label": "Daventry",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBFAL",
    "label": "Falmouth",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBGRK",
    "label": "Greenock",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBGTN",
    "label": "Garston",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBGYS",
    "label": "Grays",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBHUL",
    "label": "Hull",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBIMM",
    "label": "Immingham",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBIRL",
    "label": "Irlam",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBLEE",
    "label": "Leeds Icd",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBMID",
    "label": "Middlesborough",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBNOR",
    "label": "Normanton",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBPLY",
    "label": "Plymouth",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBPME",
    "label": "Portsmouth",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBPTL",
    "label": "Portland",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBSCP",
    "label": "Scunthorpe",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBSHE",
    "label": "Sheffield",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBSHS",
    "label": "Sheerness",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBSSH",
    "label": "South Shields",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBTIL",
    "label": "Tilbury",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBWDN",
    "label": "Widnes",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBWFD",
    "label": "Wakefield",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GDSTG",
    "label": "Saint George'S",
    "region": "Central America & Carribean",
    "country": "Grenada",
    "score": 0
  },
  {
    "unlocode": "GEBUS",
    "label": "Batumi",
    "region": "Europe Med",
    "country": "Georgia",
    "score": 0
  },
  {
    "unlocode": "GEPTI",
    "label": "Poti",
    "region": "Europe Med",
    "country": "Georgia",
    "score": 0
  },
  {
    "unlocode": "GFCAY",
    "label": "Cayenne",
    "region": "Latin America East",
    "country": "French Guiana",
    "score": 0
  },
  {
    "unlocode": "GFDDC",
    "label": "Degrad Des Cannes",
    "region": "Latin America East",
    "country": "French Guiana",
    "score": 0
  },
  {
    "unlocode": "GHKMS",
    "label": "Kumasi",
    "region": "West Africa",
    "country": "Ghana",
    "score": 0
  },
  {
    "unlocode": "GHTEM",
    "label": "Tema",
    "region": "West Africa",
    "country": "Ghana",
    "score": 0
  },
  {
    "unlocode": "GHTKD",
    "label": "Takoradi",
    "region": "West Africa",
    "country": "Ghana",
    "score": 0
  },
  {
    "unlocode": "GIGIB",
    "label": "Gibraltar",
    "region": "Europe Med",
    "country": "Gibraltar",
    "score": 0
  },
  {
    "unlocode": "GMBJL",
    "label": "Banjul",
    "region": "West Africa",
    "country": "Gambia",
    "score": 0
  },
  {
    "unlocode": "GNCKY",
    "label": "Conakry",
    "region": "West Africa",
    "country": "Guinea",
    "score": 0
  },
  {
    "unlocode": "GPBBR",
    "label": "Basse Terre",
    "region": "Central America & Carribean",
    "country": "Guadeloupe",
    "score": 0
  },
  {
    "unlocode": "GPGUS",
    "label": "Gustavia",
    "region": "Central America & Carribean",
    "country": "Guadeloupe",
    "score": 0
  },
  {
    "unlocode": "GPPTP",
    "label": "Pointe A Pitre",
    "region": "Central America & Carribean",
    "country": "Guadeloupe",
    "score": 0
  },
  {
    "unlocode": "GQBSG",
    "label": "Bata",
    "region": "West Africa",
    "country": "Equatorial Guinea",
    "score": 0
  },
  {
    "unlocode": "GQSSG",
    "label": "Malabo",
    "region": "West Africa",
    "country": "Equatorial Guinea",
    "score": 0
  },
  {
    "unlocode": "GRAST",
    "label": "Astakos",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRATH",
    "label": "Athens",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRGPA",
    "label": "Patras",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRI2A",
    "label": "Inofyta Viotas",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRLAV",
    "label": "Lavrion",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRPIR",
    "label": "Piraeus",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRSKA",
    "label": "Skaramanga",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRSKG",
    "label": "Thessaloniki",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GRVOL",
    "label": "Volos",
    "region": "Europe Med",
    "country": "Greece",
    "score": 0
  },
  {
    "unlocode": "GTESC",
    "label": "Escuintla",
    "region": "Central America & Carribean",
    "country": "Guatemala",
    "score": 0
  },
  {
    "unlocode": "GTGUA",
    "label": "Guatemala City",
    "region": "Central America & Carribean",
    "country": "Guatemala",
    "score": 0
  },
  {
    "unlocode": "GTPBR",
    "label": "Puerto Barrios",
    "region": "Central America & Carribean",
    "country": "Guatemala",
    "score": 0
  },
  {
    "unlocode": "GTPRQ",
    "label": "Puerto Quetzal",
    "region": "Central America & Carribean",
    "country": "Guatemala",
    "score": 0
  },
  {
    "unlocode": "GTSTC",
    "label": "Santo Tomas De Castilla",
    "region": "Central America & Carribean",
    "country": "Guatemala",
    "score": 0
  },
  {
    "unlocode": "GTVIN",
    "label": "Villa Nueva",
    "region": "Central America & Carribean",
    "country": "Guatemala",
    "score": 0
  },
  {
    "unlocode": "GWOXB",
    "label": "Bissau",
    "region": "West Africa",
    "country": "Guinea-Bissau",
    "score": 0
  },
  {
    "unlocode": "GYGEO",
    "label": "Georgetown",
    "region": "Latin America East",
    "country": "Guyana",
    "score": 0
  },
  {
    "unlocode": "HNPCR",
    "label": "Puerto Cortes",
    "region": "Central America & Carribean",
    "country": "Honduras",
    "score": 0
  },
  {
    "unlocode": "HNSAP",
    "label": "San Pedro Sula",
    "region": "Central America & Carribean",
    "country": "Honduras",
    "score": 0
  },
  {
    "unlocode": "HNSLO",
    "label": "San Lorenzo",
    "region": "Central America & Carribean",
    "country": "Honduras",
    "score": 0
  },
  {
    "unlocode": "HNTGU",
    "label": "Tegucigalpa",
    "region": "Central America & Carribean",
    "country": "Honduras",
    "score": 0
  },
  {
    "unlocode": "HRPLE",
    "label": "Ploce",
    "region": "Europe Med",
    "country": "Croatia",
    "score": 0
  },
  {
    "unlocode": "HRRJK",
    "label": "Rijeka",
    "region": "Europe Med",
    "country": "Croatia",
    "score": 0
  },
  {
    "unlocode": "HRSPU",
    "label": "Split",
    "region": "Europe Med",
    "country": "Croatia",
    "score": 0
  },
  {
    "unlocode": "HRZAG",
    "label": "Zagreb",
    "region": "Europe Med",
    "country": "Croatia",
    "score": 0
  },
  {
    "unlocode": "HTCAP",
    "label": "Cap Haitien",
    "region": "Central America & Carribean",
    "country": "Haiti",
    "score": 0
  },
  {
    "unlocode": "HTPAP",
    "label": "Port Au Prince",
    "region": "Central America & Carribean",
    "country": "Haiti",
    "score": 0
  },
  {
    "unlocode": "HUTKB",
    "label": "Torokbalint",
    "region": "Europe North",
    "country": "Hungary",
    "score": 0
  },
  {
    "unlocode": "IDBDJ",
    "label": "Banjarmasin",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDBDO",
    "label": "Bandung, Java",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDBEN",
    "label": "Benete",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDBIT",
    "label": "Bitung",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDBOA",
    "label": "Benoa",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDBPN",
    "label": "Balikpapan",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDBTM",
    "label": "Batam",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDBUR",
    "label": "Batu Ampal",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDDJB",
    "label": "Jambi",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDJBK",
    "label": "Jababeka, JB",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDMAK",
    "label": "Makassar",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDMES",
    "label": "Medan",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDPDG",
    "label": "Padang",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDPER",
    "label": "Perawang",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDPGX",
    "label": "Pangkal Balam, Banka",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDPKU",
    "label": "Pekanbaru, Sumatra",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDPLM",
    "label": "Palembang",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDPNK",
    "label": "Pontianak",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDSMQ",
    "label": "Sampit",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IDSRG",
    "label": "Semarang",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "IEWAT",
    "label": "Waterford (Ireland)",
    "region": "Europe North",
    "country": "Ireland",
    "score": 0
  },
  {
    "unlocode": "INAGR",
    "label": "Agra",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INAKV",
    "label": "Ankleshwar, GJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INAMD",
    "label": "Ahmedabad",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INAMG",
    "label": "Amingaon",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INAUR",
    "label": "Auraiya, UP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INBHL",
    "label": "Bhilwara",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INBLR",
    "label": "Bangalore, KA",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INBRC",
    "label": "Baroda",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INBSL",
    "label": "Bhusawal, MH",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INBWD",
    "label": "Bhiwadi, RJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INCJB",
    "label": "Coimbatore",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INDIG",
    "label": "Dighi",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INDMT",
    "label": "Dharamtar Creek, MH",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INDN1",
    "label": "Dhannad, MP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INDP1",
    "label": "Dapper, PB",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INDUR",
    "label": "Durgapur, WB",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INDU1",
    "label": "Daurai, RJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "IND2S",
    "label": "Dashrath, GJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INFBD",
    "label": "Faridabad",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INGGN",
    "label": "Gurgaon, HR",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INGHR",
    "label": "Garhi Harsaru, HR",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INGOI",
    "label": "Goa",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INGTR",
    "label": "Guntur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INGWL",
    "label": "Gwalior",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INHAL",
    "label": "Haldia",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INHYD",
    "label": "Hyderabad",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INIDR",
    "label": "Indore",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INII4",
    "label": "Irungattukottai, TN",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INISK",
    "label": "Nasik, MH",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INIXE",
    "label": "Mangalore",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INIXU",
    "label": "Aurangabad, MH",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INJAI",
    "label": "Jaipur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INJDH",
    "label": "Jodhpur, RJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INKHD",
    "label": "Kheda/Dhar, MP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INKNU",
    "label": "Kanpur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INKRI",
    "label": "Krishnapatnam, AP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INKRK",
    "label": "Karaikal, PY",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INKTU",
    "label": "Kota, RJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INKY1",
    "label": "Khodiyar Icd, GJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INLN1",
    "label": "Loni, UP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INLUH",
    "label": "Ludhiana",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMA2",
    "label": "Mandidip, MP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMD9",
    "label": "Madhosingh, UP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMOR",
    "label": "Moradabad",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMPR",
    "label": "Malanpur, MP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMRM",
    "label": "Marmagao",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMR9",
    "label": "Mahbubnagar",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMUL",
    "label": "Mulund",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPAP",
    "label": "Panipat",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPAV",
    "label": "Pipavav",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPBD",
    "label": "Porbandar",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPIR",
    "label": "Pithampur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPMP",
    "label": "Pimpri, MH",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPNP",
    "label": "Babarpur, HR",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPNQ",
    "label": "Pune",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPNY",
    "label": "Pondicherry",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPPG",
    "label": "Patparganj",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPRT",
    "label": "Paradip Garh",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPT1",
    "label": "Patli, HR",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPVL",
    "label": "Panvel, MH",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INREA",
    "label": "Rewari, HR",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INRPR",
    "label": "Raipur, MP",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INRT1",
    "label": "Ratlam",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INSN1",
    "label": "Sanand, GJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INSRE",
    "label": "Saharanpur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INTGD",
    "label": "Talegaon Dabhade",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INTKD",
    "label": "Tughlakabad",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INTR1",
    "label": "Thar Icd, RJ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INTUP",
    "label": "Tirupur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INTU2",
    "label": "Thimmapur",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INVNS",
    "label": "Varanasi",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "IN1CA",
    "label": "Chinchwad, MH",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "IQA2U",
    "label": "Abughraib",
    "region": "Middle East & ISC",
    "country": "Iraq",
    "score": 0
  },
  {
    "unlocode": "IQUQR",
    "label": "Umm Qasr",
    "region": "Middle East & ISC",
    "country": "Iraq",
    "score": 0
  },
  {
    "unlocode": "ISAKU",
    "label": "Akureyri",
    "region": "Europe North",
    "country": "Iceland",
    "score": 0
  },
  {
    "unlocode": "ISESK",
    "label": "Eskifjordhur",
    "region": "Europe North",
    "country": "Iceland",
    "score": 0
  },
  {
    "unlocode": "ISGRT",
    "label": "Grundartangi",
    "region": "Europe North",
    "country": "Iceland",
    "score": 0
  },
  {
    "unlocode": "ISREY",
    "label": "Reykjavik",
    "region": "Europe North",
    "country": "Iceland",
    "score": 0
  },
  {
    "unlocode": "ISRFJ",
    "label": "Reydarfjordur",
    "region": "Europe North",
    "country": "Iceland",
    "score": 0
  },
  {
    "unlocode": "ISSTR",
    "label": "Straumsvik",
    "region": "Europe North",
    "country": "Iceland",
    "score": 0
  },
  {
    "unlocode": "ISVA1",
    "label": "Vestmannaeyjar",
    "region": "Europe North",
    "country": "Iceland",
    "score": 0
  },
  {
    "unlocode": "ITAOI",
    "label": "Ancona",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITCAG",
    "label": "Cagliari",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITCRE",
    "label": "Cremona",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITCTA",
    "label": "Catania",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITCVV",
    "label": "Civitavecchia",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITGIT",
    "label": "Gioia Tauro",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITMOD",
    "label": "Modena",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITNVR",
    "label": "Novara",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITPCZ",
    "label": "Piacenza",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITPMO",
    "label": "Palermo",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITPZL",
    "label": "Pozzallo",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITRAN",
    "label": "Ravenna",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITREG",
    "label": "Reggio Calabria",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITRNE",
    "label": "Reggio Nell Emilia",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITRUB",
    "label": "Rubiera",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITSAU",
    "label": "Sessa Aurunca",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITSGU",
    "label": "San Guiseppe [Not Valid]",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITTAR",
    "label": "Taranto",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITTPS",
    "label": "Trapani",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITTRN",
    "label": "Turin",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITTRS",
    "label": "Trieste",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITVDL",
    "label": "Vado Ligure",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "JMKIN",
    "label": "Kingston",
    "region": "Central America & Carribean",
    "country": "Jamaica",
    "score": 0
  },
  {
    "unlocode": "JMMBJ",
    "label": "Montego Bay",
    "region": "Central America & Carribean",
    "country": "Jamaica",
    "score": 0
  },
  {
    "unlocode": "JOAMM",
    "label": "Amman",
    "region": "Middle East & ISC",
    "country": "Jordan",
    "score": 0
  },
  {
    "unlocode": "JOAQJ",
    "label": "Aqaba",
    "region": "Middle East & ISC",
    "country": "Jordan",
    "score": 0
  },
  {
    "unlocode": "JPABU",
    "label": "Aburatsu",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPAXT",
    "label": "Akita",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPCHB",
    "label": "Chiba",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPFKY",
    "label": "Fukuyama, Hiroshima",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHBK",
    "label": "Hibikishinko",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHHE",
    "label": "Hachinohe",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHIC",
    "label": "Hitachinaka",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHIJ",
    "label": "Hiroshima",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHKD",
    "label": "Hakodate",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHKT",
    "label": "Hakata/Fukuoka",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHMD",
    "label": "Hamada",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHSM",
    "label": "Hososhima",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPHTC",
    "label": "Hitachi",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPIMB",
    "label": "Imabari",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPIMI",
    "label": "Imari",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPISG",
    "label": "Ishigaki",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPISI",
    "label": "Ishikari",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPIWK",
    "label": "Iwakuni",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPIYM",
    "label": "Iyomishima",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPKCZ",
    "label": "Kochi",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPKIJ",
    "label": "Niigata",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPKMJ",
    "label": "Kumamoto",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPKNZ",
    "label": "Kanazawa",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPKRE",
    "label": "Kure",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPKUH",
    "label": "Kushiro",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPKWS",
    "label": "Kawasaki",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPMAI",
    "label": "Maizuru",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPMA1",
    "label": "Minado",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPMII",
    "label": "Miike",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPMIZ",
    "label": "Mizushima",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPMOJ",
    "label": "Moji/Kitakyushu",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPMUR",
    "label": "Muroran",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPMYJ",
    "label": "Matsuyama",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPNAH",
    "label": "Naha",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPNAN",
    "label": "Nakanoseki",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPNAO",
    "label": "Naoetsu",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPNGS",
    "label": "Nagasaki",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPOIT",
    "label": "Oita",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPOMZ",
    "label": "Omaezaki",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPONA",
    "label": "Onahama",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSA4",
    "label": "Sako",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSBS",
    "label": "Shibushi",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSDJ",
    "label": "Sendai",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSEN",
    "label": "Sendai, Kagoshima",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSHS",
    "label": "Shimonoseki",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSKT",
    "label": "Sakata",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSMN",
    "label": "Sakaiminato",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSMZ",
    "label": "Shimizu",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTAK",
    "label": "Takamatsu",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTHS",
    "label": "Toyohashi",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTKS",
    "label": "Tokushima",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTKY",
    "label": "Tokuyama",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTMK",
    "label": "Tomakomai",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTOK",
    "label": "Tokachi",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTOS",
    "label": "Toyama-Shinko",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTRG",
    "label": "Tsuruga",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPYAT",
    "label": "Yatsushiro",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPYKK",
    "label": "Yokkaichi",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "KEEMB",
    "label": "Embakasi",
    "region": "East Africa",
    "country": "Kenya",
    "score": 0
  },
  {
    "unlocode": "KEKIS",
    "label": "Kisumu",
    "region": "East Africa",
    "country": "Kenya",
    "score": 0
  },
  {
    "unlocode": "KENBO",
    "label": "Nairobi",
    "region": "East Africa",
    "country": "Kenya",
    "score": 0
  },
  {
    "unlocode": "KENUU",
    "label": "Nakuru",
    "region": "East Africa",
    "country": "Kenya",
    "score": 0
  },
  {
    "unlocode": "KGFRU",
    "label": "Bishkek",
    "region": "Central Asia",
    "country": "Kyrgyzstan",
    "score": 0
  },
  {
    "unlocode": "KHKOS",
    "label": "Sihanoukville",
    "region": "South East Asia",
    "country": "Cambodia",
    "score": 0
  },
  {
    "unlocode": "KHPNH",
    "label": "Phnom Penh",
    "region": "South East Asia",
    "country": "Cambodia",
    "score": 0
  },
  {
    "unlocode": "KMMUT",
    "label": "Mutsamudu",
    "region": "Southern Africa",
    "country": "Comoros",
    "score": 0
  },
  {
    "unlocode": "KMYVA",
    "label": "Moroni",
    "region": "Southern Africa",
    "country": "Comoros",
    "score": 0
  },
  {
    "unlocode": "KNBAS",
    "label": "Basseterre",
    "region": "Central America & Carribean",
    "country": "Saint Kitts And Nevis",
    "score": 0
  },
  {
    "unlocode": "KRCHF",
    "label": "Jinhae",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRG2M",
    "label": "Gumi",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRICH",
    "label": "Inchon",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRKAN",
    "label": "Kwangyang",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRMAS",
    "label": "Masan",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRMOK",
    "label": "Mokpo",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRPTK",
    "label": "Pyeongtaek",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRSEL",
    "label": "Seoul",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRUSN",
    "label": "Ulsan",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRYOS",
    "label": "Yeosu",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KWSAA",
    "label": "Shuaiba",
    "region": "Middle East & ISC",
    "country": "Kuwait",
    "score": 0
  },
  {
    "unlocode": "KWSWK",
    "label": "Shuwaikh",
    "region": "Middle East & ISC",
    "country": "Kuwait",
    "score": 0
  },
  {
    "unlocode": "KYGEC",
    "label": "Georgetown, Grand Cayman",
    "region": "Central America & Carribean",
    "country": "Cayman Islands",
    "score": 0
  },
  {
    "unlocode": "KZAAU",
    "label": "Aktau",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZABE",
    "label": "Aktobe",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZAKS",
    "label": "Aksay",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZAST",
    "label": "Astana",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZAS1",
    "label": "Aksu, Pav",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZBA1",
    "label": "Baykonur",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZCIT",
    "label": "Shimkent",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZDY1",
    "label": "Dostyk",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZDY2",
    "label": "Dzhaltyr",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZDZH",
    "label": "Dzhambul",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZDZN",
    "label": "Dzhezkazgan",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZGUW",
    "label": "Atyrau",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZKGF",
    "label": "Karaganda",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZKUL",
    "label": "Qulsary",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZKZO",
    "label": "Kzyl Orda",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZLA2",
    "label": "Lugovaya",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZLG2",
    "label": "Leninogorsk",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZPLX",
    "label": "Semipalatynsk",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZPPK",
    "label": "Petropavlovsk",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZPWQ",
    "label": "Pavlodar",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZTA2",
    "label": "Taldykorgan",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZTN2",
    "label": "Taincha, Sev",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZUKK",
    "label": "Ust-Kamenogorsk",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZURA",
    "label": "Ural'Sk",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZZN2",
    "label": "Zhanatas, Zha",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "KZZ2H",
    "label": "Zhana Aul",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "LAVTE",
    "label": "Vientiane",
    "region": "South East Asia",
    "country": "Laos",
    "score": 0
  },
  {
    "unlocode": "LBBEY",
    "label": "Beirut",
    "region": "Middle East & ISC",
    "country": "Lebanon",
    "score": 0
  },
  {
    "unlocode": "LCCAS",
    "label": "Castries",
    "region": "Central America & Carribean",
    "country": "Saint Lucia",
    "score": 0
  },
  {
    "unlocode": "LCSLU",
    "label": "Castries, St Lucia",
    "region": "Central America & Carribean",
    "country": "Saint Lucia",
    "score": 0
  },
  {
    "unlocode": "LCVIF",
    "label": "Vieux Fort",
    "region": "Central America & Carribean",
    "country": "Saint Lucia",
    "score": 0
  },
  {
    "unlocode": "LKGAL",
    "label": "Galle",
    "region": "Middle East & ISC",
    "country": "Sri Lanka",
    "score": 0
  },
  {
    "unlocode": "LRCPA",
    "label": "Cape Palmas",
    "region": "West Africa",
    "country": "Liberia",
    "score": 0
  },
  {
    "unlocode": "LRMLW",
    "label": "Monrovia",
    "region": "West Africa",
    "country": "Liberia",
    "score": 0
  },
  {
    "unlocode": "LRSNI",
    "label": "Sinoe",
    "region": "West Africa",
    "country": "Liberia",
    "score": 0
  },
  {
    "unlocode": "LRUCN",
    "label": "Buchanan",
    "region": "West Africa",
    "country": "Liberia",
    "score": 0
  },
  {
    "unlocode": "LUBET",
    "label": "Bettembourg",
    "region": "Europe North",
    "country": "Luxembourg",
    "score": 0
  },
  {
    "unlocode": "LYBEN",
    "label": "Bingazi",
    "region": "North Africa",
    "country": "Libya",
    "score": 0
  },
  {
    "unlocode": "LYKHO",
    "label": "El Khoms",
    "region": "North Africa",
    "country": "Libya",
    "score": 0
  },
  {
    "unlocode": "LYMRA",
    "label": "Misurata",
    "region": "North Africa",
    "country": "Libya",
    "score": 0
  },
  {
    "unlocode": "LYRLA",
    "label": "Ra'S Lanuf",
    "region": "North Africa",
    "country": "Libya",
    "score": 0
  },
  {
    "unlocode": "LYTIP",
    "label": "Tripoli",
    "region": "North Africa",
    "country": "Libya",
    "score": 0
  },
  {
    "unlocode": "MAAGA",
    "label": "Agadir",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MAAHU",
    "label": "Al Hoceima",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MAEUN",
    "label": "Laayoune",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MAFEZ",
    "label": "Fez",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MAMEK",
    "label": "Meknes",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MANDR",
    "label": "Nador",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MAOUD",
    "label": "Oujda",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MARAK",
    "label": "Marrakech",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MASFI",
    "label": "Safi",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MATNG",
    "label": "Tangier",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MATR1",
    "label": "Taourirt, Ouj",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MAVIL",
    "label": "Dakhla",
    "region": "North Africa",
    "country": "Morocco",
    "score": 0
  },
  {
    "unlocode": "MDGIU",
    "label": "Giurgiulesti",
    "region": "Europe Med",
    "country": "Moldova",
    "score": 0
  },
  {
    "unlocode": "MEBAR",
    "label": "Bar",
    "region": "Europe Med",
    "country": "Montenegro",
    "score": 0
  },
  {
    "unlocode": "MGBMD",
    "label": "Belo",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGEHL",
    "label": "Port D'Ehoala",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGMJN",
    "label": "Majunga",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGMNJ",
    "label": "Mananjary",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGMOQ",
    "label": "Morondava",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGNOS",
    "label": "Nossi Be",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGTLE",
    "label": "Tulear",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGTLN",
    "label": "Taolagnaro",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGTMM",
    "label": "Tamatave",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGTNR",
    "label": "Antananarivo",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGVOH",
    "label": "Vohemar",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MGWVK",
    "label": "Manakara",
    "region": "Southern Africa",
    "country": "Madagascar",
    "score": 0
  },
  {
    "unlocode": "MLBKO",
    "label": "Bamako",
    "region": "West Africa",
    "country": "Mali",
    "score": 0
  },
  {
    "unlocode": "MLKYS",
    "label": "Kayes",
    "region": "West Africa",
    "country": "Mali",
    "score": 0
  },
  {
    "unlocode": "MLMZI",
    "label": "Mopti",
    "region": "West Africa",
    "country": "Mali",
    "score": 0
  },
  {
    "unlocode": "MLSIK",
    "label": "Sikasso",
    "region": "West Africa",
    "country": "Mali",
    "score": 0
  },
  {
    "unlocode": "MLSZU",
    "label": "Segou",
    "region": "West Africa",
    "country": "Mali",
    "score": 0
  },
  {
    "unlocode": "MOMFM",
    "label": "Macau (Macao)",
    "region": "North East Asia",
    "country": "Macao",
    "score": 0
  },
  {
    "unlocode": "MQFDF",
    "label": "Fort De France",
    "region": "Central America & Carribean",
    "country": "Martinique",
    "score": 0
  },
  {
    "unlocode": "MRNDB",
    "label": "Nouadhibou",
    "region": "West Africa",
    "country": "Mauritania",
    "score": 0
  },
  {
    "unlocode": "MRNKC",
    "label": "Nouakchott",
    "region": "West Africa",
    "country": "Mauritania",
    "score": 0
  },
  {
    "unlocode": "MSLTB",
    "label": "Little Bay",
    "region": "Central America & Carribean",
    "country": "Montserrat",
    "score": 0
  },
  {
    "unlocode": "MTMLA",
    "label": "Malta(Freeport)",
    "region": "Europe Med",
    "country": "Malta",
    "score": 0
  },
  {
    "unlocode": "MUPLU",
    "label": "Port Louis",
    "region": "East Africa",
    "country": "Mauritius",
    "score": 0
  },
  {
    "unlocode": "MUPMA",
    "label": "Port Mathurin",
    "region": "East Africa",
    "country": "Mauritius",
    "score": 0
  },
  {
    "unlocode": "MVMLE",
    "label": "Male",
    "region": "South East Asia",
    "country": "Maldives",
    "score": 0
  },
  {
    "unlocode": "MWBLZ",
    "label": "Blantyre",
    "region": "Southern Africa",
    "country": "Malawi",
    "score": 0
  },
  {
    "unlocode": "MWLLW",
    "label": "Lilongwe",
    "region": "Southern Africa",
    "country": "Malawi",
    "score": 0
  },
  {
    "unlocode": "MXAGU",
    "label": "Aguascalientes",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXCUM",
    "label": "Cuautla Morelos",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXESE",
    "label": "Ensenada",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXGDL",
    "label": "Guadalajara",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXLZC",
    "label": "Lazaro Cardenas",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXMEX",
    "label": "Mexico City",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXMTY",
    "label": "Monterrey",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXMXL",
    "label": "Mexicali",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXOCO",
    "label": "Ocotlan",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXQRO",
    "label": "Queretaro",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXSLP",
    "label": "San Luis Potosi",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXTAM",
    "label": "Tampico",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXTIJ",
    "label": "Tijuana",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXTLC",
    "label": "Toluca",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXTUX",
    "label": "Tuxpan",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXVER",
    "label": "Veracruz",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXZLO",
    "label": "Manzanillo (Mexico)",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MX1AL",
    "label": "Distrito Federal",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MYBKI",
    "label": "Kota Kinabalu",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYBTU",
    "label": "Bintulu",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYKCH",
    "label": "Kuching",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYKUA",
    "label": "Kuantan",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYLBU",
    "label": "Labuan",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYMYY",
    "label": "Miri",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYN2N",
    "label": "Nilai Megeri Semilan",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYSBW",
    "label": "Sibu",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYSDK",
    "label": "Sandakan",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYSPT",
    "label": "Sipitang",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MYTWU",
    "label": "Tawau",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "MZBEW",
    "label": "Beira",
    "region": "Southern Africa",
    "country": "Mozambique",
    "score": 0
  },
  {
    "unlocode": "MZMNC",
    "label": "Nacala",
    "region": "Southern Africa",
    "country": "Mozambique",
    "score": 0
  },
  {
    "unlocode": "MZMPM",
    "label": "Maputo",
    "region": "Southern Africa",
    "country": "Mozambique",
    "score": 0
  },
  {
    "unlocode": "MZPOL",
    "label": "Pemba",
    "region": "Southern Africa",
    "country": "Mozambique",
    "score": 0
  },
  {
    "unlocode": "MZUEL",
    "label": "Quelimane",
    "region": "Southern Africa",
    "country": "Mozambique",
    "score": 0
  },
  {
    "unlocode": "NAWDH",
    "label": "Windhoek",
    "region": "Southern Africa",
    "country": "Namibia",
    "score": 0
  },
  {
    "unlocode": "NAWVB",
    "label": "Walvis Bay",
    "region": "Southern Africa",
    "country": "Namibia",
    "score": 0
  },
  {
    "unlocode": "NCNOU",
    "label": "Noumea",
    "region": "Oceania",
    "country": "New Caledonia",
    "score": 0
  },
  {
    "unlocode": "NCPNY",
    "label": "Prony",
    "region": "Oceania",
    "country": "New Caledonia",
    "score": 0
  },
  {
    "unlocode": "NCUVE",
    "label": "Ouvea",
    "region": "Oceania",
    "country": "New Caledonia",
    "score": 0
  },
  {
    "unlocode": "NCVAV",
    "label": "Vavouto",
    "region": "Oceania",
    "country": "New Caledonia",
    "score": 0
  },
  {
    "unlocode": "NEMFQ",
    "label": "Maradi",
    "region": "North America",
    "country": "Niger",
    "score": 0
  },
  {
    "unlocode": "NENIM",
    "label": "Niamey",
    "region": "North America",
    "country": "Niger",
    "score": 0
  },
  {
    "unlocode": "NERLT",
    "label": "Arlit",
    "region": "North America",
    "country": "Niger",
    "score": 0
  },
  {
    "unlocode": "NEZND",
    "label": "Zinder",
    "region": "North America",
    "country": "Niger",
    "score": 0
  },
  {
    "unlocode": "NGAPP",
    "label": "Apapa",
    "region": "West Africa",
    "country": "Nigeria",
    "score": 0
  },
  {
    "unlocode": "NGCBQ",
    "label": "Calabar",
    "region": "West Africa",
    "country": "Nigeria",
    "score": 0
  },
  {
    "unlocode": "NGONN",
    "label": "Onne",
    "region": "West Africa",
    "country": "Nigeria",
    "score": 0
  },
  {
    "unlocode": "NGTIN",
    "label": "Tincan/Lagos",
    "region": "West Africa",
    "country": "Nigeria",
    "score": 0
  },
  {
    "unlocode": "NICIO",
    "label": "Corinto",
    "region": "Central America & Carribean",
    "country": "Nicaragua",
    "score": 0
  },
  {
    "unlocode": "NIMGA",
    "label": "Managua",
    "region": "Central America & Carribean",
    "country": "Nicaragua",
    "score": 0
  },
  {
    "unlocode": "NLAMS",
    "label": "Amsterdam",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLAPN",
    "label": "Alphen Ad Rijn",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLBON",
    "label": "Born",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLBZM",
    "label": "Bergen Op Zoom",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLEEM",
    "label": "Eemshaven",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLGOR",
    "label": "Gorinchem",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLGRQ",
    "label": "Groningen",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLHGL",
    "label": "Hengelo",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLHTB",
    "label": "'S-Hertogenbosch",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLKAM",
    "label": "Kampen",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLLWR",
    "label": "Leeuwarden",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLMEP",
    "label": "Meppel",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLMEW",
    "label": "Meerlo-Wansum",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLMOE",
    "label": "Moerdijk",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLNIJ",
    "label": "Nijmegen",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLOOS",
    "label": "Oosterhout",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLOSS",
    "label": "Oss",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLRID",
    "label": "Ridderkerk",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLVDM",
    "label": "Veendam",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLVEG",
    "label": "Veghel",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLVEL",
    "label": "Velsen",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLVEN",
    "label": "Venlo",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLVLI",
    "label": "Vlissingen",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLWLK",
    "label": "Waalwijk",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLZAA",
    "label": "Zaandam",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NOAES",
    "label": "Alesund",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOBGO",
    "label": "Bergen (Norway)",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOBOO",
    "label": "Bodo",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOBVK",
    "label": "Brevik",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOEGE",
    "label": "Egersund",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOFNE",
    "label": "Finnsnes",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOFRK",
    "label": "Fredrikstad",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOFRO",
    "label": "Floro",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOGJM",
    "label": "Gjemnes",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOHAL",
    "label": "Halden",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOHAU",
    "label": "Haugesund",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOKRV",
    "label": "Knarvik",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOKVD",
    "label": "Kvinesdal",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOLAR",
    "label": "Larvik",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOLND",
    "label": "Lyngdal",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOMAY",
    "label": "Maloy",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOORK",
    "label": "Orkanger",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOOSL",
    "label": "Oslo",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOSAT",
    "label": "Salten",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOSAU",
    "label": "Sauda",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOSJA",
    "label": "Husoy",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOSKE",
    "label": "Skien",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOSTM",
    "label": "Straumen",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOSVE",
    "label": "Svelgen",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOSVG",
    "label": "Stavanger",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOTRD",
    "label": "Trondheim",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NRINU",
    "label": "Nauru Island",
    "region": "Oceania",
    "country": "Nauru",
    "score": 0
  },
  {
    "unlocode": "NZASG",
    "label": "Ashburton, Can",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZBAL",
    "label": "Balclutha",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZBHE",
    "label": "Blenheim",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZBLU",
    "label": "Bluff",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZCHC",
    "label": "Christchurch",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZDUD",
    "label": "Dunedin",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZGIS",
    "label": "Gisborne",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZGMN",
    "label": "Greymouth",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZHLZ",
    "label": "Hamilton",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZIVC",
    "label": "Invercargill",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZLYT",
    "label": "Lyttelton",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZMMU",
    "label": "Mount Maunganui",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZMOR",
    "label": "Morrinsville",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZMRT",
    "label": "Marton",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZNPL",
    "label": "New Plymouth",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZNSN",
    "label": "Nelson",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZOAM",
    "label": "Oamaru",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZPCN",
    "label": "Picton",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZPMR",
    "label": "Palmerston North",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZPOE",
    "label": "Port Chalmers",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZTIU",
    "label": "Timaru",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZTKA",
    "label": "Temuka",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZTRG",
    "label": "Tauranga",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZWAG",
    "label": "Wanganui",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZWLG",
    "label": "Wellington",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "NZWRE",
    "label": "Whangarei",
    "region": "Oceania",
    "country": "New Zealand",
    "score": 0
  },
  {
    "unlocode": "OMMNQ",
    "label": "Mina Qaboos",
    "region": "Middle East & ISC",
    "country": "Oman",
    "score": 0
  },
  {
    "unlocode": "OMRAY",
    "label": "Raysut",
    "region": "Middle East & ISC",
    "country": "Oman",
    "score": 0
  },
  {
    "unlocode": "OMSLL",
    "label": "Salalah",
    "region": "Middle East & ISC",
    "country": "Oman",
    "score": 0
  },
  {
    "unlocode": "PABLB",
    "label": "Balboa",
    "region": "Central America & Carribean",
    "country": "Panama",
    "score": 0
  },
  {
    "unlocode": "PACTB",
    "label": "Cristobal",
    "region": "Central America & Carribean",
    "country": "Panama",
    "score": 0
  },
  {
    "unlocode": "PAMIT",
    "label": "Manzanillo (Panama)",
    "region": "Central America & Carribean",
    "country": "Panama",
    "score": 0
  },
  {
    "unlocode": "PAONX",
    "label": "Colon",
    "region": "Central America & Carribean",
    "country": "Panama",
    "score": 0
  },
  {
    "unlocode": "PAPTY",
    "label": "Panama City",
    "region": "Central America & Carribean",
    "country": "Panama",
    "score": 0
  },
  {
    "unlocode": "PAROD",
    "label": "Rodman",
    "region": "Central America & Carribean",
    "country": "Panama",
    "score": 0
  },
  {
    "unlocode": "PECHM",
    "label": "Chimbote",
    "region": "Latin America West",
    "country": "Peru",
    "score": 0
  },
  {
    "unlocode": "PEILQ",
    "label": "Ilo",
    "region": "Latin America West",
    "country": "Peru",
    "score": 0
  },
  {
    "unlocode": "PEMRI",
    "label": "Matarani",
    "region": "Latin America West",
    "country": "Peru",
    "score": 0
  },
  {
    "unlocode": "PEPAI",
    "label": "Paita",
    "region": "Latin America West",
    "country": "Peru",
    "score": 0
  },
  {
    "unlocode": "PESVY",
    "label": "Salaverry",
    "region": "Latin America West",
    "country": "Peru",
    "score": 0
  },
  {
    "unlocode": "PETCQ",
    "label": "Tacna",
    "region": "Latin America West",
    "country": "Peru",
    "score": 0
  },
  {
    "unlocode": "PE1AE",
    "label": "Arica Muelle",
    "region": "Latin America West",
    "country": "Peru",
    "score": 0
  },
  {
    "unlocode": "PFPPT",
    "label": "Papeete",
    "region": "Oceania",
    "country": "French Polynesia",
    "score": 0
  },
  {
    "unlocode": "PFU2R",
    "label": "Mururoa",
    "region": "Oceania",
    "country": "French Polynesia",
    "score": 0
  },
  {
    "unlocode": "PGBUA",
    "label": "Buka Island",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGGUR",
    "label": "Alotau",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGKIE",
    "label": "Kieta",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGKIM",
    "label": "Kimbe",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGKVG",
    "label": "Kavieng",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGLAE",
    "label": "Lae",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGLOR",
    "label": "Lorengau",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGMAG",
    "label": "Madang",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGMTK",
    "label": "Motukea Island",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGPOM",
    "label": "Port Moresby",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGRAB",
    "label": "Rabaul",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGROR",
    "label": "Orobay",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGVAI",
    "label": "Vanimo",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PGWWK",
    "label": "Wewak",
    "region": "South East Asia",
    "country": "Papua New Guinea",
    "score": 0
  },
  {
    "unlocode": "PHBIY",
    "label": "Biyawa",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHBTG",
    "label": "Batangas",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHBUG",
    "label": "Bugo",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHCEB",
    "label": "Cebu",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHCGY",
    "label": "Cagayan De Oro",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHDVO",
    "label": "Davao",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHGES",
    "label": "General Santos",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHILO",
    "label": "Iloilo",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHMNL",
    "label": "Manila",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHSFS",
    "label": "Subic Bay",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHU2U",
    "label": "Butuan City",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHZAM",
    "label": "Zamboanga",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PKBQM",
    "label": "Port Qasim",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 0
  },
  {
    "unlocode": "PKMUX",
    "label": "Multan",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 0
  },
  {
    "unlocode": "PKRWP",
    "label": "Rawalpindi",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 0
  },
  {
    "unlocode": "PKSKT",
    "label": "Sialkot",
    "region": "Middle East & ISC",
    "country": "Pakistan",
    "score": 0
  },
  {
    "unlocode": "PLQLC",
    "label": "Gliwice",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "PLSWI",
    "label": "Swinoujscie",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "PLSZZ",
    "label": "Szczecin",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "PRBAY",
    "label": "Bayamon",
    "region": "Central America & Carribean",
    "country": "Puerto Rico",
    "score": 0
  },
  {
    "unlocode": "PRSJU",
    "label": "San Juan",
    "region": "Central America & Carribean",
    "country": "Puerto Rico",
    "score": 0
  },
  {
    "unlocode": "PTCNL",
    "label": "Canical",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "PTELV",
    "label": "Elvas",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "PTFDF",
    "label": "Figueira Da Foz",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "PTPRV",
    "label": "Praia Da Vitoria",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "PTRIA",
    "label": "Riachos",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "PTSET",
    "label": "Setubal",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "PTSIE",
    "label": "Sines",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "PYASU",
    "label": "Asuncion",
    "region": "Latin America East",
    "country": "Paraguay",
    "score": 0
  },
  {
    "unlocode": "PYPIL",
    "label": "Pilar",
    "region": "Latin America East",
    "country": "Paraguay",
    "score": 0
  },
  {
    "unlocode": "QADOH",
    "label": "Doha",
    "region": "Middle East & ISC",
    "country": "Qatar",
    "score": 0
  },
  {
    "unlocode": "QAUMS",
    "label": "Umm Said",
    "region": "Middle East & ISC",
    "country": "Qatar",
    "score": 0
  },
  {
    "unlocode": "REPDG",
    "label": "Pointe Des Galets",
    "region": "East Africa",
    "country": "Reunion",
    "score": 0
  },
  {
    "unlocode": "ROBA3",
    "label": "Bradu De Sus",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROBCM",
    "label": "Bacau",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROBUH",
    "label": "Bucuresti",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROCND",
    "label": "Constanta",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROCUT",
    "label": "Curtici",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROMCA",
    "label": "Miercurea-Ciuc",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROME1",
    "label": "Mioveni",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROOMR",
    "label": "Oradea",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROPLT",
    "label": "Ploiesti",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "RORAU",
    "label": "Radauti",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "RORIV",
    "label": "Ramnicu Valcea",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROVD1",
    "label": "Vintu De Jos",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "RSBEG",
    "label": "Belgrade",
    "region": "Europe Med",
    "country": "Serbia",
    "score": 0
  },
  {
    "unlocode": "RUARH",
    "label": "Arkhangelsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKDT",
    "label": "Kronstadt",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKGD",
    "label": "Kaliningrad",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKOR",
    "label": "Korsakov",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKUF",
    "label": "Samara",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUNJK",
    "label": "Nakhodka",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUPEE",
    "label": "Perm",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUSOC",
    "label": "Sochi",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUTAG",
    "label": "Taganrog",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUTTI",
    "label": "Tolyatti",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUUFA",
    "label": "Ufa",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUULU",
    "label": "Ust'-Luga",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUVYP",
    "label": "Vostochnyy, Port",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RWKGL",
    "label": "Kigali",
    "region": "East Africa",
    "country": "Rwanda",
    "score": 0
  },
  {
    "unlocode": "SAKAC",
    "label": "King Abdullah City",
    "region": "Middle East & ISC",
    "country": "Saudi Arabia",
    "score": 0
  },
  {
    "unlocode": "SARUH",
    "label": "Riyadh, Door",
    "region": "Middle East & ISC",
    "country": "Saudi Arabia",
    "score": 0
  },
  {
    "unlocode": "SAYBI",
    "label": "Yanbu Industrial City",
    "region": "Middle East & ISC",
    "country": "Saudi Arabia",
    "score": 0
  },
  {
    "unlocode": "SBHIR",
    "label": "Honiara",
    "region": "Oceania",
    "country": "Solomon Islands",
    "score": 0
  },
  {
    "unlocode": "SCPOV",
    "label": "Port Victoria",
    "region": "East Africa",
    "country": "Seychelles",
    "score": 0
  },
  {
    "unlocode": "SDKRT",
    "label": "Khartoum",
    "region": "East Africa",
    "country": "Sudan",
    "score": 0
  },
  {
    "unlocode": "SDPZU",
    "label": "Port Sudan",
    "region": "East Africa",
    "country": "Sudan",
    "score": 0
  },
  {
    "unlocode": "SEAHU",
    "label": "Ahus",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEALM",
    "label": "Almhult",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEGVX",
    "label": "Gaevle",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEHSG",
    "label": "Hallsberg, T",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEMMA",
    "label": "Malmo",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SENRK",
    "label": "Norrkoping",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SENSJ",
    "label": "Nassjo, F",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEOXE",
    "label": "Oxelosund",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SESDL",
    "label": "Sundsvall",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SESOE",
    "label": "Soedertaelje",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SESTO",
    "label": "Stockholm",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEVGD",
    "label": "Vaggeryd, F",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEVST",
    "label": "Vasteras",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SIKOP",
    "label": "Koper",
    "region": "Europe Med",
    "country": "Slovenia",
    "score": 0
  },
  {
    "unlocode": "SILJU",
    "label": "Ljubljana",
    "region": "Europe Med",
    "country": "Slovenia",
    "score": 0
  },
  {
    "unlocode": "SIMBX",
    "label": "Maribor",
    "region": "Europe Med",
    "country": "Slovenia",
    "score": 0
  },
  {
    "unlocode": "SKBTS",
    "label": "Bratislava, Apt",
    "region": "Europe Med",
    "country": "Slovakia",
    "score": 0
  },
  {
    "unlocode": "SKILZ",
    "label": "Zilina",
    "region": "Europe Med",
    "country": "Slovakia",
    "score": 0
  },
  {
    "unlocode": "SKKSC",
    "label": "Kosice",
    "region": "Europe Med",
    "country": "Slovakia",
    "score": 0
  },
  {
    "unlocode": "SKSLV",
    "label": "Sladkovicovo",
    "region": "Europe Med",
    "country": "Slovakia",
    "score": 0
  },
  {
    "unlocode": "SLFNA",
    "label": "Freetown",
    "region": "West Africa",
    "country": "Sierra Leone",
    "score": 0
  },
  {
    "unlocode": "SNDKR",
    "label": "Dakar",
    "region": "West Africa",
    "country": "Senegal",
    "score": 0
  },
  {
    "unlocode": "SOMGQ",
    "label": "Mogadishu",
    "region": "East Africa",
    "country": "Somalia",
    "score": 0
  },
  {
    "unlocode": "SRPBM",
    "label": "Paramaribo",
    "region": "Latin America East",
    "country": "Suriname",
    "score": 0
  },
  {
    "unlocode": "SSJUB",
    "label": "Juba, EC",
    "region": "East Africa",
    "country": "South Sudan",
    "score": 0
  },
  {
    "unlocode": "STTMS",
    "label": "Sao Tome Prn",
    "region": "West Africa",
    "country": "Sao Tome And Principe",
    "score": 0
  },
  {
    "unlocode": "SVAQJ",
    "label": "Acajutla",
    "region": "Central America & Carribean",
    "country": "El Salvador",
    "score": 0
  },
  {
    "unlocode": "SVLUN",
    "label": "La Union",
    "region": "Central America & Carribean",
    "country": "El Salvador",
    "score": 0
  },
  {
    "unlocode": "SVSAL",
    "label": "San Salvador",
    "region": "Central America & Carribean",
    "country": "El Salvador",
    "score": 0
  },
  {
    "unlocode": "SYLTK",
    "label": "Lattakia",
    "region": "Middle East & ISC",
    "country": "Syrian Arab Republic",
    "score": 0
  },
  {
    "unlocode": "SYTTS",
    "label": "Tartous",
    "region": "Middle East & ISC",
    "country": "Syrian Arab Republic",
    "score": 0
  },
  {
    "unlocode": "TDMQQ",
    "label": "Moundou",
    "region": "North Africa",
    "country": "Chad",
    "score": 0
  },
  {
    "unlocode": "TDNDJ",
    "label": "N'Djamena",
    "region": "North Africa",
    "country": "Chad",
    "score": 0
  },
  {
    "unlocode": "TDSRH",
    "label": "Sarh",
    "region": "North Africa",
    "country": "Chad",
    "score": 0
  },
  {
    "unlocode": "TFPFR",
    "label": "Port-Aux-Francais",
    "region": "Oceania",
    "country": "French Southern Territories",
    "score": 0
  },
  {
    "unlocode": "TGLFW",
    "label": "Lome",
    "region": "West Africa",
    "country": "Togo",
    "score": 0
  },
  {
    "unlocode": "THBGP",
    "label": "Bangpakong",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 0
  },
  {
    "unlocode": "THSGZ",
    "label": "Songkhla Port",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 0
  },
  {
    "unlocode": "THURT",
    "label": "Surat Thani",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 0
  },
  {
    "unlocode": "TJDYU",
    "label": "Dushanbe",
    "region": "Central Asia",
    "country": "Tajikistan",
    "score": 0
  },
  {
    "unlocode": "TJLBD",
    "label": "Khudzhand",
    "region": "Central Asia",
    "country": "Tajikistan",
    "score": 0
  },
  {
    "unlocode": "TLDIL",
    "label": "Dili",
    "region": "South East Asia",
    "country": "Timor-Leste",
    "score": 0
  },
  {
    "unlocode": "TMASB",
    "label": "Ashkhabad",
    "region": "Central Asia",
    "country": "Turkmenistan",
    "score": 0
  },
  {
    "unlocode": "TNBIZ",
    "label": "Bizerte",
    "region": "North Africa",
    "country": "Tunisia",
    "score": 0
  },
  {
    "unlocode": "TNGAE",
    "label": "Gabes",
    "region": "North Africa",
    "country": "Tunisia",
    "score": 0
  },
  {
    "unlocode": "TNLGN",
    "label": "La Goulette",
    "region": "North Africa",
    "country": "Tunisia",
    "score": 0
  },
  {
    "unlocode": "TNSFA",
    "label": "Sfax",
    "region": "North Africa",
    "country": "Tunisia",
    "score": 0
  },
  {
    "unlocode": "TNTUN",
    "label": "Tunis / Rades",
    "region": "North Africa",
    "country": "Tunisia",
    "score": 0
  },
  {
    "unlocode": "TRADK",
    "label": "Anadolukavagi",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRALI",
    "label": "Aliaga",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "Tscore",
    "label": "Ankara",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRAYT",
    "label": "Antalya",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRBDM",
    "label": "Bandirma",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRCKZ",
    "label": "Canakkale",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRGZT",
    "label": "Gaziantep",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRKCM",
    "label": "Kahramanmaras",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRKMN",
    "label": "Karaman",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRKYA",
    "label": "Konya",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRNEM",
    "label": "Nemrut Bay",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRSSX",
    "label": "Samsun",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRTUZ",
    "label": "Tuzla",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TRTZX",
    "label": "Trabzon",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "TTPOS",
    "label": "Port Of Spain",
    "region": "Central America & Carribean",
    "country": "Trinidad And Tobago",
    "score": 0
  },
  {
    "unlocode": "TTPTS",
    "label": "Point Lisas",
    "region": "Central America & Carribean",
    "country": "Trinidad And Tobago",
    "score": 0
  },
  {
    "unlocode": "TWHSZ",
    "label": "Hsin-Chu",
    "region": "North East Asia",
    "country": "Taiwan",
    "score": 0
  },
  {
    "unlocode": "TWTPE",
    "label": "Taipei",
    "region": "North East Asia",
    "country": "Taiwan",
    "score": 0
  },
  {
    "unlocode": "TWTYN",
    "label": "Taoyuan",
    "region": "North East Asia",
    "country": "Taiwan",
    "score": 0
  },
  {
    "unlocode": "TZDAR",
    "label": "Dar Es Salaam",
    "region": "East Africa",
    "country": "Tanzania",
    "score": 0
  },
  {
    "unlocode": "TZMYW",
    "label": "Mtwara",
    "region": "East Africa",
    "country": "Tanzania",
    "score": 0
  },
  {
    "unlocode": "TZTGT",
    "label": "Tanga",
    "region": "East Africa",
    "country": "Tanzania",
    "score": 0
  },
  {
    "unlocode": "TZZNZ",
    "label": "Zanzibar",
    "region": "East Africa",
    "country": "Tanzania",
    "score": 0
  },
  {
    "unlocode": "UADNK",
    "label": "Dnepropetrovsk",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "UAILK",
    "label": "Ilyichevsk",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "UAMPW",
    "label": "Mariupol",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "UAYUZ",
    "label": "Yuzhnyy",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "UGEBB",
    "label": "Entebbe",
    "region": "East Africa",
    "country": "Uganda",
    "score": 0
  },
  {
    "unlocode": "UGJIN",
    "label": "Jinja",
    "region": "East Africa",
    "country": "Uganda",
    "score": 0
  },
  {
    "unlocode": "UGKLA",
    "label": "Kampala",
    "region": "East Africa",
    "country": "Uganda",
    "score": 0
  },
  {
    "unlocode": "USAAI",
    "label": "Alpharetta, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USABE",
    "label": "Easton, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USABQ",
    "label": "Albuquerque, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USADF",
    "label": "Cordele, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USADN",
    "label": "Ashdown, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAER",
    "label": "Ayer, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAFL",
    "label": "Bluefield, WV",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAGS",
    "label": "Augusta, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAIA",
    "label": "Alliance, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAIO",
    "label": "Atlantic, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAKH",
    "label": "Akron, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USALL",
    "label": "Allegan, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAMA",
    "label": "Amarillo, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USARK",
    "label": "Arkansas City, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USARY",
    "label": "Amory, MS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USASL",
    "label": "Marshall, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USATL",
    "label": "Atlanta, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAUJ",
    "label": "Auburn, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAUL",
    "label": "Austell, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAUZ",
    "label": "Aurora, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAVD",
    "label": "Avondale, LA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAVE",
    "label": "Avenel, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAWM",
    "label": "West Memphis, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAWN",
    "label": "Allentown, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAYO",
    "label": "Canyon, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USAYS",
    "label": "Waycross, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USA2L",
    "label": "Burgin, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USA2P",
    "label": "Burnside, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USA4E",
    "label": "Cumberland, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBAL",
    "label": "Baltimore, MD",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBAY",
    "label": "Bayonne, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBCT",
    "label": "Boca Raton, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBCU",
    "label": "Blue Island, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBDP",
    "label": "Bedford Park, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBEX",
    "label": "Bethlehem, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBFL",
    "label": "Bakersfield, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBFS",
    "label": "Bristol, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBG3",
    "label": "Bulls Gap, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBHM",
    "label": "Birmingham, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBKU",
    "label": "Brooklyn, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBLN",
    "label": "Belen, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBNA",
    "label": "Nashville, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBND",
    "label": "Burleson, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBNE",
    "label": "Blaine, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBNW",
    "label": "Boone, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBOS",
    "label": "Boston, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBRO",
    "label": "Brownsville, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBTQ",
    "label": "Benton, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBUB",
    "label": "Bruceton, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBUF",
    "label": "Buffalo, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBYB",
    "label": "Boynton Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBZW",
    "label": "Barstow, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USB34",
    "label": "Bartlettsville, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCAE",
    "label": "Columbia, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCBE",
    "label": "Cumberland, MD",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCDS",
    "label": "Childress, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCGH",
    "label": "Chicago Heights, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCG1",
    "label": "Big Sandy, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCHA",
    "label": "Chattanooga, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCHH",
    "label": "Channahon, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCHM",
    "label": "Champlain, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCH2",
    "label": "Chillicothe, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCID",
    "label": "Cedar Rapids, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCLT",
    "label": "Charlotte, NC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCMH",
    "label": "Columbus, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCMT",
    "label": "Commerce City, CO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCNJ",
    "label": "Colonial Heights, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCOI",
    "label": "Cocoa, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCPG",
    "label": "College Park, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCPR",
    "label": "Casper, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCQP",
    "label": "Connellsville, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCQZ",
    "label": "Chester, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCRC",
    "label": "Commerce/Los Angeles, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCRU",
    "label": "Carson, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCSF",
    "label": "Carteret, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCSL",
    "label": "San Luis Obispo, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCSQ",
    "label": "Creston, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCSV",
    "label": "Crossville, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCSZ",
    "label": "Chester, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCUE",
    "label": "Cumberland, RI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCVG",
    "label": "Cincinnati, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCVN",
    "label": "Clovis, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCV9",
    "label": "Caseyville, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCWI",
    "label": "Clinton, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCXL",
    "label": "Calexico, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCXO",
    "label": "Conroe, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCYS",
    "label": "Cheyenne, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCZU",
    "label": "Conley, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDAB",
    "label": "Daytona Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDAD",
    "label": "Dania Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDBN",
    "label": "Dublin, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDCB",
    "label": "DeKalb, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDEE",
    "label": "Deerfield Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDEN",
    "label": "Denver, CO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDEO",
    "label": "Dearborn, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDET",
    "label": "Detroit, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDEY",
    "label": "Delray Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDHT",
    "label": "Dalhart, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDNN",
    "label": "Dalton, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDQN",
    "label": "Dolton, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDSM",
    "label": "Des Moines, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDSZ",
    "label": "Denison, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDUG",
    "label": "Douglas, AZ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDUP",
    "label": "Dupo, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDVK",
    "label": "Danville, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDVN",
    "label": "Davenport, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDVR",
    "label": "Danvers, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDWH",
    "label": "Dilworth, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDXE",
    "label": "Dexter, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEAG",
    "label": "Eagle Point, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEAT",
    "label": "Wenatchee, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEED",
    "label": "Needles, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEGP",
    "label": "Eagle Pass, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEKI",
    "label": "Elkhart, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEKO",
    "label": "Elko, NV",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USELP",
    "label": "El Paso, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEMP",
    "label": "Emporia, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USENG",
    "label": "Englewood Cliffs, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEP9",
    "label": "Estes Park, CO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USESX",
    "label": "Eddystone, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEVA",
    "label": "Evadale, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEVV",
    "label": "Evansville, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEWI",
    "label": "Elwood, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEWR",
    "label": "Newark, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USEZA",
    "label": "Elizabeth, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFAR",
    "label": "Fargo, ND",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFAT",
    "label": "Fresno, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFBN",
    "label": "Fairburn, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFDW",
    "label": "Federal Way, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFET",
    "label": "Fremont, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFIK",
    "label": "Fishkill, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFLD",
    "label": "Fond du Lac, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFLL",
    "label": "Fort Lauderdale, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFLO",
    "label": "Florence, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFMS",
    "label": "Fort Madison, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFOP",
    "label": "Forest Park, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFPO",
    "label": "Freeport, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFPR",
    "label": "Fort Pierce, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFPY",
    "label": "Perry, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFRQ",
    "label": "Fscorefort, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFRR",
    "label": "Front Royal, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFSK",
    "label": "Fort Scott, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFSM",
    "label": "Fort Smith, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFTX",
    "label": "Friona, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFUL",
    "label": "Fullerton, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFWA",
    "label": "Fort Wayne, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USFWT",
    "label": "Fort Worth, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGAC",
    "label": "Gardena, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGBG",
    "label": "Galesburg, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGBO",
    "label": "Greensboro, NC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGCC",
    "label": "Gillette, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGCG",
    "label": "Garden City, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGCM",
    "label": "Garden City, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGDP",
    "label": "Grand Prairie, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGEG",
    "label": "Spokane, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGEO",
    "label": "Georgetown, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGEY",
    "label": "Greybull, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGFK",
    "label": "Grand Forks, ND",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGIF",
    "label": "Winter Haven, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGIW",
    "label": "Grinnell, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGI1",
    "label": "Ivor, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGLE",
    "label": "Gainesville, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGLH",
    "label": "Greenville, MS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGLO",
    "label": "Gloucester, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGPK",
    "label": "Galena Park, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGPT",
    "label": "Gulfport, MS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGRB",
    "label": "Green Bay, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGRI",
    "label": "Grand Island, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGSC",
    "label": "Goose Creek, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGSG",
    "label": "Glasgow, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGSP",
    "label": "Greenville-Greer Apt, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGTV",
    "label": "Graniteville, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGUS",
    "label": "Peru, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGVP",
    "label": "Groveport, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGVT",
    "label": "Greenville, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGXX",
    "label": "Greer, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USG1Q",
    "label": "Ethel, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHDO",
    "label": "Henderson, CO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHEA",
    "label": "Hearne, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHGR",
    "label": "Hagerstown, MD",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHID",
    "label": "Hidalgo, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHIL",
    "label": "Hills, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHLF",
    "label": "Hialeah, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHLN",
    "label": "Helena, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHMX",
    "label": "Humble, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHNB",
    "label": "Huntingburg, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHNL",
    "label": "Honolulu, HI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHO1",
    "label": "Grundy, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHPE",
    "label": "Shepherd, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHPG",
    "label": "Hughes Springs, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHRY",
    "label": "Harvey, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHSU",
    "label": "Hillsborough, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHSV",
    "label": "Huntsville, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHTC",
    "label": "Hutchins, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHUF",
    "label": "Terre Haute, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHVR",
    "label": "Havre, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHYY",
    "label": "Henry, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHYZ",
    "label": "Harriman, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USICT",
    "label": "Wichita, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USIFR",
    "label": "Ranier, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USILM",
    "label": "Wilmington, NC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USILV",
    "label": "Silvis, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USIMK",
    "label": "Mokena, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USIND",
    "label": "Indianapolis, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USINT",
    "label": "Winston Salem, NC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USINW",
    "label": "Winslow, AZ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USIOW",
    "label": "Iowa City, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USIRT",
    "label": "Irving, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USIS0",
    "label": "Echo, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USITN",
    "label": "Smithton, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USITO",
    "label": "Hilo, HI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USITS",
    "label": "Itasca, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJAN",
    "label": "Jackson, MS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJAX",
    "label": "Jacksonville, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJBR",
    "label": "Jonesboro, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJEC",
    "label": "Jersey City, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJEF",
    "label": "Jefferson City, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJID",
    "label": "City of Industry, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJOT",
    "label": "Joliet, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USJPT",
    "label": "Jupiter, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USKCK",
    "label": "Kansas City, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USKEC",
    "label": "Kellogg, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USKET",
    "label": "Kent, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USKIN",
    "label": "Kings Mountain, NC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USKSW",
    "label": "Kennesaw, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USKWH",
    "label": "Kawaihae, HI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLAQ",
    "label": "Lawrenceburg, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLAS",
    "label": "Las Vegas, NV",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLBB",
    "label": "Lubbock, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLBD",
    "label": "Lebanon, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLBF",
    "label": "North Platte, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLBN",
    "label": "Lebanon, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLDJ",
    "label": "Linden, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLEX",
    "label": "Lexington, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLFT",
    "label": "Lafayette, LA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLHS",
    "label": "Lithia Springs, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLIO",
    "label": "Lithonia, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLIT",
    "label": "Little Rock, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLMI",
    "label": "La Mirada, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLMJ",
    "label": "Lemont, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLNK",
    "label": "Lincoln, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLNT",
    "label": "Lantana, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLNZ",
    "label": "Linwood, NC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLRD",
    "label": "Laredo, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLRO",
    "label": "Lathrop, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLRU",
    "label": "Las Cruces, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLSB",
    "label": "Lordsburg, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLSE",
    "label": "La Crosse, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLUI",
    "label": "Louisville, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLVV",
    "label": "La Vergne, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLWC",
    "label": "Lawrence, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLXN",
    "label": "Lexington, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLYH",
    "label": "Lynchburg, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USL1X",
    "label": "Yeso, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMAZ",
    "label": "Madison, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMBV",
    "label": "Middleburg Heights, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMBY",
    "label": "Moberly, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMCH",
    "label": "McDonough, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMCK",
    "label": "McCook, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMCN",
    "label": "Macon, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMCO",
    "label": "McCook, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMCQ",
    "label": "McIntyre, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMDD",
    "label": "Midland Airpark, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMDY",
    "label": "Medley, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMEI",
    "label": "Meridian, MS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMEM",
    "label": "Memphis, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMGO",
    "label": "Marengo, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMIB",
    "label": "Midlothian, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMIE",
    "label": "Muncie, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMIW",
    "label": "Marshalltown, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMIX",
    "label": "Mineola, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMKC",
    "label": "Kansas City, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMKE",
    "label": "Milwaukee, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMKL",
    "label": "Jackson, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMKM",
    "label": "Markham, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMKO",
    "label": "Muskogee, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMLB",
    "label": "Melbourne, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMLC",
    "label": "McAlester, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMLF",
    "label": "Milford, UT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMLU",
    "label": "Monroe, LA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMNS",
    "label": "Mansfield, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMNY",
    "label": "Manchester, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMOB",
    "label": "Mobile, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMOT",
    "label": "Minot, ND",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMOV",
    "label": "Marceline, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMQM",
    "label": "Marion, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMRW",
    "label": "Morrow, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMSO",
    "label": "Missoula, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMSP",
    "label": "Minneapolis/St Paul Apt, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMSS",
    "label": "Massena, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMSY",
    "label": "New Orleans, LA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMWV",
    "label": "Middletown, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMXG",
    "label": "Marlboro (Marlborough), MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMYE",
    "label": "Marysville, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNBH",
    "label": "North Baltimore, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNBJ",
    "label": "New Brunswick, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNCK",
    "label": "Nicholasville, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNCP",
    "label": "New Castle, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNEK",
    "label": "Newark, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNGZ",
    "label": "Alameda, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNOA",
    "label": "North Aurora, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNOF",
    "label": "Altoona, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNPV",
    "label": "Naperville, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNR6",
    "label": "Newkirk, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNTS",
    "label": "North Charleston, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USODB",
    "label": "Ormond Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOGD",
    "label": "Ogden, UT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOKC",
    "label": "Oklahoma City, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOLV",
    "label": "Olive Branch, MS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOMA",
    "label": "Omaha, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USORF",
    "label": "Norfolk, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USORH",
    "label": "Worcester, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USORL",
    "label": "Orlando, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOVE",
    "label": "Oroville, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOXO",
    "label": "Oxford, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOYI",
    "label": "Oneida, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOYN",
    "label": "Brooklyn, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USO7S",
    "label": "Ridgeway, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPAH",
    "label": "Paducah, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPAS",
    "label": "Pasadena, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPAY",
    "label": "Perth Amboy, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPBF",
    "label": "Pine Bluff, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPBI",
    "label": "West Palm Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPBY",
    "label": "Palm Bay, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPCF",
    "label": "Pitcairn, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPCJ",
    "label": "Princeton, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPEB",
    "label": "Port Elizabeth, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPEF",
    "label": "Port Everglades, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPEQ",
    "label": "Pecos, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPFX",
    "label": "Pharr, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPHL",
    "label": "Philadelphia, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPHX",
    "label": "Phoenix, AZ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPIA",
    "label": "Peoria, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPIT",
    "label": "Pittsburgh, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPLG",
    "label": "Plaines, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPLQ",
    "label": "Plaquemine, LA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPMH",
    "label": "Portsmouth, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPND",
    "label": "Pearland, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPNS",
    "label": "Pensacola, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPOC",
    "label": "La Verne, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPOF",
    "label": "Poplar Bluff, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPOO",
    "label": "Polo, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPPA",
    "label": "Pampa, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPPF",
    "label": "Parsons, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPPM",
    "label": "Pompano Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPSC",
    "label": "Pasco, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPSN",
    "label": "Palestine, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPSZ",
    "label": "Parsons, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPTM",
    "label": "Portsmouth, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPTS",
    "label": "Pittsburg, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPTT",
    "label": "Pratt, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPWN",
    "label": "Port Wentworth, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USPZL",
    "label": "Port Saint Lucie, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USP1S",
    "label": "Mannford, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USP4C",
    "label": "Pine Castle, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USP7Z",
    "label": "Watts, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USP83",
    "label": "Waynoka, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USQGT",
    "label": "Garrett, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USQIG",
    "label": "Meigs, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USQ7I",
    "label": "Conway, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRAH",
    "label": "Rahway, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRAL",
    "label": "Riverside, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRBC",
    "label": "Riviera Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRCX",
    "label": "Rochelle, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRDO",
    "label": "Rancho Dominguez, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRFD",
    "label": "Rockford, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRIC",
    "label": "Richmond, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRID",
    "label": "Richmond, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRIK",
    "label": "Rincon, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRKH",
    "label": "Rock Hill, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRKI",
    "label": "Rock Island, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRNK",
    "label": "Fscorelin, LA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USROA",
    "label": "Roanoke, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USROC",
    "label": "Rochester, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRSG",
    "label": "Rosenberg, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRST",
    "label": "Rochester, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRTO",
    "label": "Colton, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRVD",
    "label": "Ravenna, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRVR",
    "label": "Green River, UT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRWI",
    "label": "Rocky Mount, NC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRWL",
    "label": "Rawlins, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRX0",
    "label": "Rose City, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSAA",
    "label": "Saratoga, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSAC",
    "label": "Sacramento, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSAN",
    "label": "San Diego, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSAT",
    "label": "San Antonio, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSBT",
    "label": "San Bernardino, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSCK",
    "label": "Stockton, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSFO",
    "label": "San Francisco, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSGC",
    "label": "South Gate, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSGF",
    "label": "Springfield, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSGT",
    "label": "Stuttgart, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSHF",
    "label": "Sheffield, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSHP",
    "label": "Sherman, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSHR",
    "label": "Sheridan, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSID",
    "label": "Schiller Park, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSKI",
    "label": "Selkirk, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSLC",
    "label": "Salt Lake City, UT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSLO",
    "label": "Salem, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSLS",
    "label": "Salisbury, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSME",
    "label": "Somerset, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSMY",
    "label": "Smyrna, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSNQ",
    "label": "Savanna, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSPA",
    "label": "Spartanburg, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSPS",
    "label": "Wichita Falls, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSQF",
    "label": "Sepulveda, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSQN",
    "label": "Shepherdsville, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSTB",
    "label": "Stafford, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSTC",
    "label": "Saint Cloud, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSTE",
    "label": "Stevens Point, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSTJ",
    "label": "Saint Joseph, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSTL",
    "label": "Saint Louis, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSTP",
    "label": "Saint Paul, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSTR",
    "label": "Streator, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSUA",
    "label": "Stuart, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSUF",
    "label": "Suffolk, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSWW",
    "label": "Sweetwater, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSXT",
    "label": "Santa Teresa, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSYI",
    "label": "Shelbyville, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSYR",
    "label": "Syracuse, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSZG",
    "label": "Sebastian, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSZV",
    "label": "Southborough, MA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "96,00 USS",
    "label": "Edgemont, SD",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTAS",
    "label": "Stearns, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTC6",
    "label": "Sunbright, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTIX",
    "label": "Titusville, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTIY",
    "label": "Terminal Island, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTNU",
    "label": "Newton, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTOA",
    "label": "Torrance, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTOL",
    "label": "Toledo, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTOP",
    "label": "Topeka, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTPA",
    "label": "Tampa, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTPL",
    "label": "Temple, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTUL",
    "label": "Tulsa, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTUS",
    "label": "Tucson International Apt, AZ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTVI",
    "label": "Thomasville, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTXC",
    "label": "McAllen, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTXH",
    "label": "Randolph Center, VT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USTXK",
    "label": "Texarkana, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "UST9O",
    "label": "Oakdale, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUAI",
    "label": "Cleveland, TN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUC5",
    "label": "Miami, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUEL",
    "label": "Bunnell, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUFG",
    "label": "Chesapeake, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUJN",
    "label": "Hanahan, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUQF",
    "label": "La Porte, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUST",
    "label": "Saint Augustine, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUV1",
    "label": "Morgan, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUXK",
    "label": "Neenah, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUZO",
    "label": "Warwick, RI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USU5L",
    "label": "Hemphill, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USU79",
    "label": "Kempner, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USU9P",
    "label": "Loraine, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USVAB",
    "label": "Virginia Beach, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USVAN",
    "label": "Vancouver, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USVAO",
    "label": "Avon, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USVBM",
    "label": "Van Buren Township, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USVN2",
    "label": "Vaughn, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USVRB",
    "label": "Vero Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USVVK",
    "label": "Staples, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USV18",
    "label": "Somerville, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWBG",
    "label": "Walbridge, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWDG",
    "label": "Enid, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWDW",
    "label": "Wendover, WY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWEX",
    "label": "Wellington, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWFH",
    "label": "Wando, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWGO",
    "label": "Winchester, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWLA",
    "label": "Willard, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWMC",
    "label": "Winnemucca, NV",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWMH",
    "label": "Mountain Home, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWMX",
    "label": "West Monroe, LA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWPS",
    "label": "Wabasso, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWRT",
    "label": "Warrenton, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWTC",
    "label": "Watson, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWTN",
    "label": "Wilmington, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWXI",
    "label": "Whitefish, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWYH",
    "label": "Wylie, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWYQ",
    "label": "Wynne, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWZG",
    "label": "Willow Springs, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXAK",
    "label": "Alva, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXAX",
    "label": "Appomattox, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXBX",
    "label": "Bellevue, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXDN",
    "label": "Cicero, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXEW",
    "label": "Englewood, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXLP",
    "label": "Silsbee, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXME",
    "label": "Slaton, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXMV",
    "label": "Summit, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXM3",
    "label": "Ames, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXWT",
    "label": "Whitestown, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXX1",
    "label": "Wishram, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USX7K",
    "label": "Odessa, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USX9A",
    "label": "Skykomish, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USYE0",
    "label": "Agudo, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USYF0",
    "label": "Romeo, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USYG0",
    "label": "Savoy, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USYT9",
    "label": "West Colton, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USYUM",
    "label": "Yuma, AZ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USY7G",
    "label": "Stoddard, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USZBB",
    "label": "Bald Knob, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USZI7",
    "label": "Booneville, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USZLV",
    "label": "Longview, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USZL6",
    "label": "Wilton, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USZX0",
    "label": "Lowell, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USZY0",
    "label": "Courtney, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USZZ0",
    "label": "Morris, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0BP",
    "label": "Oak Grove, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JL",
    "label": "Thenard, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JM",
    "label": "Esperanza, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JN",
    "label": "Hauser, ID",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JO",
    "label": "Interbay, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JQ",
    "label": "Cardenas, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JR",
    "label": "Duoro, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JS",
    "label": "Ricardo, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JT",
    "label": "Sharon, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JU",
    "label": "Barstow, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JV",
    "label": "Greenwood, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JX",
    "label": "Bonaventure, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0JY",
    "label": "Viera, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0KA",
    "label": "Sloan, NV",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US0KC",
    "label": "Allouez, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US1JZ",
    "label": "Williamson, WV",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US1LN",
    "label": "Manalapan, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US1S4",
    "label": "Kings Mountain, KY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US2NJ",
    "label": "Mohave Valley, AZ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US2VD",
    "label": "Sedgwick, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US236",
    "label": "De Queen, AR",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US3FP",
    "label": "Portola, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US3GQ",
    "label": "Argos, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US3TQ",
    "label": "Baring, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US338",
    "label": "Valentine, AZ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US4MY",
    "label": "Thayer, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US4QP",
    "label": "Grant, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US4S2",
    "label": "Laurel, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US41W",
    "label": "Yermo, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5B3",
    "label": "Anita, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5FR",
    "label": "De Soto, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5NE",
    "label": "Hancock, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5NR",
    "label": "Hawkeye, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5NY",
    "label": "New Smyrna Beach, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5Q7",
    "label": "Dexter, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5Z4",
    "label": "Durant, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US5Z6",
    "label": "Earlham, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US6BK",
    "label": "Webster, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US6B7",
    "label": "Walcott, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US6C9",
    "label": "Stuart, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US6JD",
    "label": "Pawnee City, NE",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US6R4",
    "label": "El Rito, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US6TY",
    "label": "Melrose, NM",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US6VZ",
    "label": "Victor, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US616",
    "label": "Homestead, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US64Y",
    "label": "Mechanicsville, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US648",
    "label": "Malcom, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US65I",
    "label": "Missouri Valley, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US65X",
    "label": "Moscow, IA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US7PR",
    "label": "Pike Road, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US7WV",
    "label": "Gorham, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US7W2",
    "label": "Geneseo, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US74O",
    "label": "Bureau, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US78W",
    "label": "Eola, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US8LJ",
    "label": "Heavener, OK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US8PK",
    "label": "Pembroke Pines, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US8ZG",
    "label": "Port Orange, FL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US83K",
    "label": "Sheffield, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US87F",
    "label": "Williamsfield, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US9AQ",
    "label": "Atkinson, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US9EQ",
    "label": "Crewe, VA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US9FU",
    "label": "Strong City, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US9VR",
    "label": "Milan, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US9W5",
    "label": "Herington, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US93J",
    "label": "Wolcott, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US96D",
    "label": "Chase, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US978",
    "label": "Danville, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US98Q",
    "label": "Fredonia, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US99U",
    "label": "Harper, KS",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "UYMVD",
    "label": "Montevideo",
    "region": "Latin America East",
    "country": "Uruguay",
    "score": 0
  },
  {
    "unlocode": "UZAGN",
    "label": "Ohangaron",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZBHK",
    "label": "Bukhara",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZKSQ",
    "label": "Karshi",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZNMA",
    "label": "Namangan",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZNWY",
    "label": "Navoiy",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZSKD",
    "label": "Samarkand",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZZAR",
    "label": "Zarafshan",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "VCCRP",
    "label": "Campden Park",
    "region": "Central America & Carribean",
    "country": "Saint Vincent And The Grenadines",
    "score": 0
  },
  {
    "unlocode": "VCKTN",
    "label": "Kingstown",
    "region": "Central America & Carribean",
    "country": "Saint Vincent And The Grenadines",
    "score": 0
  },
  {
    "unlocode": "VEBLA",
    "label": "Barcelona (Venezuela)",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VEEGU",
    "label": "El Guamache",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VEETV",
    "label": "El Tablazo/Maracaibo L",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VEGUB",
    "label": "Guaranao",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VEGUT",
    "label": "Guanta",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VELAG",
    "label": "La Guaira",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VEMAR",
    "label": "Maracaibo",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VEPBL",
    "label": "Puerto Cabello",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "VGRAD",
    "label": "Road Town",
    "region": "Central America & Carribean",
    "country": "Virgin Islands, British",
    "score": 0
  },
  {
    "unlocode": "VICHA",
    "label": "Charlotte Amalie, St Thomas",
    "region": "Central America & Carribean",
    "country": "Virgin Islands, U.S.",
    "score": 0
  },
  {
    "unlocode": "VICTD",
    "label": "Christiansted",
    "region": "Central America & Carribean",
    "country": "Virgin Islands, U.S.",
    "score": 0
  },
  {
    "unlocode": "VNBN1",
    "label": "Bac Ninh",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "VNPHG",
    "label": "Phuoc Long",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "VNTCG",
    "label": "Tan Cang / Newport",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "VNVUT",
    "label": "Vung Tau",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "VUSAN",
    "label": "Santo",
    "region": "Oceania",
    "country": "Vanuatu",
    "score": 0
  },
  {
    "unlocode": "VUSON",
    "label": "Espiritu Santo",
    "region": "Oceania",
    "country": "Vanuatu",
    "score": 0
  },
  {
    "unlocode": "VUVLI",
    "label": "Port Vila",
    "region": "Oceania",
    "country": "Vanuatu",
    "score": 0
  },
  {
    "unlocode": "WFFUT",
    "label": "Futuna Island",
    "region": "Oceania",
    "country": "Wallis And Futuna",
    "score": 0
  },
  {
    "unlocode": "WFMAU",
    "label": "Mata'Utu",
    "region": "Oceania",
    "country": "Wallis And Futuna",
    "score": 0
  },
  {
    "unlocode": "YEADE",
    "label": "Aden",
    "region": "Middle East & ISC",
    "country": "Yemen",
    "score": 0
  },
  {
    "unlocode": "YEHOD",
    "label": "Hodeidah",
    "region": "Middle East & ISC",
    "country": "Yemen",
    "score": 0
  },
  {
    "unlocode": "YEMKX",
    "label": "Mukalla",
    "region": "Middle East & ISC",
    "country": "Yemen",
    "score": 0
  },
  {
    "unlocode": "YEMOK",
    "label": "Mokha",
    "region": "Middle East & ISC",
    "country": "Yemen",
    "score": 0
  },
  {
    "unlocode": "YTLON",
    "label": "Longoni",
    "region": "East Africa",
    "country": "Mayotte",
    "score": 0
  },
  {
    "unlocode": "ZAJNB",
    "label": "Johannesburg",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 0
  },
  {
    "unlocode": "ZAPRY",
    "label": "Pretoria",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 0
  },
  {
    "unlocode": "ZAZBA",
    "label": "Coega",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 0
  },
  {
    "unlocode": "ZMCIP",
    "label": "Chipata",
    "region": "Southern Africa",
    "country": "Zambia",
    "score": 0
  },
  {
    "unlocode": "ZMKIW",
    "label": "Kitwe",
    "region": "Southern Africa",
    "country": "Zambia",
    "score": 0
  },
  {
    "unlocode": "ZMLUN",
    "label": "Lusaka",
    "region": "Southern Africa",
    "country": "Zambia",
    "score": 0
  },
  {
    "unlocode": "ZMNLA",
    "label": "Ndola",
    "region": "Southern Africa",
    "country": "Zambia",
    "score": 0
  },
  {
    "unlocode": "ZMSLI",
    "label": "Solwezi",
    "region": "Southern Africa",
    "country": "Zambia",
    "score": 0
  },
  {
    "unlocode": "ZWBUQ",
    "label": "Bulawayo",
    "region": "Southern Africa",
    "country": "Zimbabwe",
    "score": 0
  },
  {
    "unlocode": "ZWHRE",
    "label": "Harare",
    "region": "Southern Africa",
    "country": "Zimbabwe",
    "score": 0
  },
  {
    "unlocode": "ZWUTA",
    "label": "Mutare",
    "region": "Southern Africa",
    "country": "Zimbabwe",
    "score": 0
  },
  {
    "unlocode": "MXPGO",
    "label": "Progreso",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "SISL_Sunny Island",
    "label": "Sunny Island",
    "region": "Europe Med",
    "country": "Slovenia",
    "score": 0
  },
  {
    "unlocode": "CLCHB",
    "label": "Chacabuco",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "ASPPG",
    "label": "Pago Pago",
    "region": "Oceania",
    "country": "American Samoa",
    "score": 0
  },
  {
    "unlocode": "WSAPW",
    "label": "Apia",
    "region": "Oceania",
    "country": "Samoa",
    "score": 0
  },
  {
    "unlocode": "TOTBU",
    "label": "Nuku'Alofa",
    "region": "Oceania",
    "country": "Tonga",
    "score": 0
  },
  {
    "unlocode": "DEDRS",
    "label": "Dresden / Riesa",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "GBALY",
    "label": "Alconbury",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "PTOPO",
    "label": "Oporto",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "ILHFA",
    "label": "Haifa",
    "region": "Middle East & ISC",
    "country": "Israel",
    "score": 0
  },
  {
    "unlocode": "BRSME",
    "label": "Sumare",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRSZN",
    "label": "Suzano",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "ARCNQ",
    "label": "Corrientes",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARPUD",
    "label": "Puerto Deseado",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARMDQ",
    "label": "Mar Del Plata",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARPMY",
    "label": "Puerto Madryn",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "ARSAE",
    "label": "San Antonio Del Este",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "VEVLN",
    "label": "Valencia (Venezuela)",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "ARCOR",
    "label": "Cordoba",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "BEDEL",
    "label": "Doel",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "DEBFN",
    "label": "Bad Salzuflen",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEKRE",
    "label": "Krefeld",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DENUL",
    "label": "Neu Ulm",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "EGEED",
    "label": "Dekheila",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "ITCLG",
    "label": "Casalgrande It",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITVDI",
    "label": "Villanova D Asti It",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "OMMCT",
    "label": "Muscat Om",
    "region": "Middle East & ISC",
    "country": "Oman",
    "score": 0
  },
  {
    "unlocode": "PTLEP",
    "label": "Leca Da Palmeira",
    "region": "Europe Med",
    "country": "Portugal",
    "score": 0
  },
  {
    "unlocode": "RURND",
    "label": "Rostov-Na-Donu Ru",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "TREYP",
    "label": "Evyap",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "CHNTT",
    "label": "Niederglatt Ch",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 0
  },
  {
    "unlocode": "CZOSR",
    "label": "Ostrava",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "DEFFO",
    "label": "Brieskow-Finkenheerd",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEMNZ",
    "label": "Monzingen",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "EGEDK",
    "label": "El Dekheila",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "EGSOK",
    "label": "Sokhna Port",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "ESNIN",
    "label": "Noain",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "INBHW",
    "label": "Bhawanigarh",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INDHA",
    "label": "Dhannad/Indore",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INJUC",
    "label": "Jalandhar In",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INLNI",
    "label": "Loni",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INNDA",
    "label": "Noida",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPNK",
    "label": "Klppl-Icd/Panki",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INPTL",
    "label": "Patli",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INSND",
    "label": "Sonepat",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "IQBGW",
    "label": "Baghdad",
    "region": "Middle East & ISC",
    "country": "Iraq",
    "score": 0
  },
  {
    "unlocode": "LYTOB",
    "label": "Tobruk",
    "region": "North Africa",
    "country": "Libya",
    "score": 0
  },
  {
    "unlocode": "MYPGB",
    "label": "Padang Besar",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "OMOPQ",
    "label": "Port Qaboos Om",
    "region": "Middle East & ISC",
    "country": "Oman",
    "score": 0
  },
  {
    "unlocode": "SKBAB",
    "label": "Bratislava Port",
    "region": "Europe Med",
    "country": "Slovakia",
    "score": 0
  },
  {
    "unlocode": "TRLMA",
    "label": "Limas",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "IDUPG",
    "label": "Ujung Pandang",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "INURA",
    "label": "Uran",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INGZB",
    "label": "Ghaziabad",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "JPMRW",
    "label": "Morioka",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPOTG",
    "label": "Ota",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTSB",
    "label": "Tsukuba",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "KRCHW",
    "label": "Changwon",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "PHMAN",
    "label": "Mandaue",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "PHCAL",
    "label": "Calamba",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "THSSN",
    "label": "Samut Sakorn",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 0
  },
  {
    "unlocode": "VNBHA",
    "label": "Bien Hoa",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "VNTHD",
    "label": "Thu Dau Mot",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "DKTTR",
    "label": "Tastrup",
    "region": "Europe North",
    "country": "Denmark",
    "score": 0
  },
  {
    "unlocode": "GBCMG",
    "label": "Cambridge",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBTLQ",
    "label": "Totton",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBBQN",
    "label": "Burnaston",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBCVT",
    "label": "Coventry",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBDSE",
    "label": "Deeside",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "ITZYA",
    "label": "Dinazzano",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITPZF",
    "label": "Pozzolo Formigaro",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "DEBOY",
    "label": "Bad Oeynhausen",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEBTL",
    "label": "Baunatal",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DESKO",
    "label": "Schkopau",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DESCW",
    "label": "Schweinfurt",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEGHM",
    "label": "Gernsheim",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "NLMST",
    "label": "Maastricht",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "CHRKG",
    "label": "Rekingen",
    "region": "Europe North",
    "country": "Switzerland",
    "score": 0
  },
  {
    "unlocode": "DELUG",
    "label": "Ludwigsburg",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "BEAVL",
    "label": "Avelgem",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "BEGNE",
    "label": "Gent",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "NLASD",
    "label": "Assendelft",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "PLLRK",
    "label": "Krosniewice",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "RUVSE",
    "label": "Vsevolozhsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "SEUME",
    "label": "Umea",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "ARMPU",
    "label": "Maipu",
    "region": "Latin America East",
    "country": "Argentina",
    "score": 0
  },
  {
    "unlocode": "CLSBD",
    "label": "San Bernardo",
    "region": "Latin America West",
    "country": "Chile",
    "score": 0
  },
  {
    "unlocode": "LA_Caldas",
    "label": "Caldas",
    "region": "South East Asia",
    "country": "Laos",
    "score": 0
  },
  {
    "unlocode": "MXELS",
    "label": "El Salto",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXZAP",
    "label": "Zapopan",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXCUT",
    "label": "Cuautitlan Izcalli",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "LA_Zuazua",
    "label": "Zuazua",
    "region": "South East Asia",
    "country": "Laos",
    "score": 0
  },
  {
    "unlocode": "MXESC",
    "label": "Escobedo",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXSIL",
    "label": "Silao",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "MXSMC",
    "label": "Salamanca",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "VEPSU",
    "label": "Puerto Sucre",
    "region": "Latin America East",
    "country": "Venezuela",
    "score": 0
  },
  {
    "unlocode": "NA_Newfoundland",
    "label": "Newfoundland",
    "region": "Southern Africa",
    "country": "Namibia",
    "score": 0
  },
  {
    "unlocode": "USOGG",
    "label": "Kahului, HI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNIJ",
    "label": "Nawiliwili, HI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRM3",
    "label": "Raymond, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGRR",
    "label": "Grand Rapids, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "KRCHN",
    "label": "Chonju",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRTJN",
    "label": "Daejeon",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRYSN",
    "label": "Yangsan",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "JPISS",
    "label": "Isa",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPOTK",
    "label": "Otake",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "VNDNA",
    "label": "Dong Nai",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "INBAH",
    "label": "Bahadurgarh",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMDP",
    "label": "Mandapam",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INMUM",
    "label": "Ahmednagar",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "JOAQB",
    "label": "Aqaba",
    "region": "Middle East & ISC",
    "country": "Jordan",
    "score": 0
  },
  {
    "unlocode": "USSPQ",
    "label": "San Pedro, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "CANNO",
    "label": "Nanaimo, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAYEA",
    "label": "Alta Lake, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "USADZ",
    "label": "Ada, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGSU",
    "label": "Galesburg, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLIE",
    "label": "Lindside, WV",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMBS",
    "label": "Bay City-Saginaw-Midland Apt, MI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USMXH",
    "label": "Mount Vernon, IN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBQL",
    "label": "Burkville, AL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USCST",
    "label": "Charleston, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USGES",
    "label": "Geneseo, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USKIP",
    "label": "Tokio, TX",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSSI",
    "label": "Brunswick, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHSX",
    "label": "Hoschton, GA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHAR",
    "label": "Harrisburg, PA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSKK",
    "label": "Shaktoolik, AK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUZK",
    "label": "Waterford, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "NLHRV",
    "label": "Heerenveen",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "NLVNO",
    "label": "Veenoord",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "BEYZO",
    "label": "Laakdal",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "DECLN",
    "label": "Brickeln",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEDMG",
    "label": "Dormagen",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DELUA",
    "label": "LÃ£Å“bbenau",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEWLR",
    "label": "Weil Am Rhein",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "ATWLR",
    "label": "Weiler",
    "region": "Europe North",
    "country": "Austria",
    "score": 0
  },
  {
    "unlocode": "SESDJ",
    "label": "Sandsjofors",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SESTP",
    "label": "Staffanstorp",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "NOASV",
    "label": "Austevoll",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "NOIKR",
    "label": "Ikornnes",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "ITVBA",
    "label": "Vignole Borbera",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "USXHE",
    "label": "Kearny, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "KWKWI",
    "label": "Kuwait",
    "region": "Middle East & ISC",
    "country": "Kuwait",
    "score": 0
  },
  {
    "unlocode": "GBCLV",
    "label": "Cleveland",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "KREIW",
    "label": "Euiwang",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "ZANCT",
    "label": "Ngqura",
    "region": "Southern Africa",
    "country": "South Africa",
    "score": 0
  },
  {
    "unlocode": "THSCT",
    "label": "Siam Container Transport & Terminal Co., Ltd.",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 0
  },
  {
    "unlocode": "MXSGU",
    "label": "Silao Guanajuato",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "CAPRG",
    "label": "Prince George, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CAPRR",
    "label": "Prince Rupert, BC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "USCPF",
    "label": "Chippewa Falls, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "GETBS",
    "label": "Tbilisi",
    "region": "Europe Med",
    "country": "Georgia",
    "score": 0
  },
  {
    "unlocode": "MXTUL",
    "label": "Tula De Allende, Hid",
    "region": "North America",
    "country": "Mexico",
    "score": 0
  },
  {
    "unlocode": "ROBRV",
    "label": "Brasov",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROCRV",
    "label": "Craiova",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROSBS",
    "label": "Sebes",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROSUN",
    "label": "Suceava",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "ROZAU",
    "label": "Zalau",
    "region": "Europe Med",
    "country": "Romania",
    "score": 0
  },
  {
    "unlocode": "TNSUS",
    "label": "Sousse",
    "region": "North Africa",
    "country": "Tunisia",
    "score": 0
  },
  {
    "unlocode": "USBZY",
    "label": "Blue Springs, MO",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USBPO",
    "label": "Brook Park, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USHVS",
    "label": "Hartsville, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXIF",
    "label": "Macedonia, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USXJR",
    "label": "Norwalk, OH",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USWBZ",
    "label": "Woodbridge, NJ",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "ESPMI",
    "label": "Palma De Mallorca",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "EGBDR",
    "label": "Badr",
    "region": "North Africa",
    "country": "Egypt",
    "score": 0
  },
  {
    "unlocode": "PLSIC",
    "label": "Siechnice",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "ESCAR",
    "label": "Cartagena (Spain)",
    "region": "Europe Med",
    "country": "Spain",
    "score": 0
  },
  {
    "unlocode": "USQLP",
    "label": "Lake Point, UT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "US8RE",
    "label": "Milton, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USRLS",
    "label": "Redlands, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USSUI",
    "label": "South Holland, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "RSNVS",
    "label": "Novi Sad",
    "region": "Europe Med",
    "country": "Serbia",
    "score": 0
  },
  {
    "unlocode": "SOKMU",
    "label": "Kismayu",
    "region": "East Africa",
    "country": "Somalia",
    "score": 0
  },
  {
    "unlocode": "NOTAE",
    "label": "Tananger",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "MTMAR",
    "label": "Marsaxlokk",
    "region": "Europe Med",
    "country": "Malta",
    "score": 0
  },
  {
    "unlocode": "USLWS",
    "label": "Lewiston, ID",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "IDMRK",
    "label": "Merak (Java)",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "AUGLT",
    "label": "Gladstone",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "KITRW",
    "label": "Tarawa",
    "region": "Oceania",
    "country": "Kiribati",
    "score": 0
  },
  {
    "unlocode": "MHMAJ",
    "label": "Majuro",
    "region": "Oceania",
    "country": "Marshall Islands",
    "score": 0
  },
  {
    "unlocode": "GUGUM",
    "label": "Guam",
    "region": "Oceania",
    "country": "Guam",
    "score": 0
  },
  {
    "unlocode": "INKAT",
    "label": "Kattupalli",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "GBNWP",
    "label": "Newport",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "RUABA",
    "label": "Abakan",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUBAX",
    "label": "Barnaul",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUBLG",
    "label": "Blagoveschensk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUCSY",
    "label": "Cheboksary",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUIJK",
    "label": "Izhevsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKEJ",
    "label": "Kemerovo",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKRR",
    "label": "Krasnodar",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RULNX",
    "label": "Smolensk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUNVK",
    "label": "Novocheboksarsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUPKV",
    "label": "Pskov",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUREN",
    "label": "Orenburg",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RURTW",
    "label": "Saratov",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RURZN",
    "label": "Ryazan",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUSGC",
    "label": "Surgut",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUSOV",
    "label": "Sovetskiy",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUSTW",
    "label": "Stavropol",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUTJM",
    "label": "Tyumen",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUTOF",
    "label": "Tomsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUULY",
    "label": "Ulyanovsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUUUD",
    "label": "Ulan-Ude",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUVMR",
    "label": "Vladimir",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUVOG",
    "label": "Volgograd",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUZHL",
    "label": "Zheleznodorozhniy",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "DELBC",
    "label": "Lubeck",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "FIPOR",
    "label": "Pori",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "FIVAL",
    "label": "Valko",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "UABRO",
    "label": "Brovary",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "UADOK",
    "label": "Donetsk",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "UAHRK",
    "label": "Kharkov",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "BEREK",
    "label": "Rekkem",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "DEASC",
    "label": "Aschaffenburg",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "UAVIN",
    "label": "Vinnytsya",
    "region": "Europe North",
    "country": "Ukraine",
    "score": 0
  },
  {
    "unlocode": "GBBHW",
    "label": "Billingham/Haverton",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "FITJO",
    "label": "Tesjoki",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "NODRM",
    "label": "Drammen",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "ILBEV",
    "label": "Beer Sheva",
    "region": "Middle East & ISC",
    "country": "Israel",
    "score": 0
  },
  {
    "unlocode": "NLBEK",
    "label": "Beek",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "DERSK",
    "label": "Rostock",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEBGE",
    "label": "Bergen (Germany)",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "GBCDT",
    "label": "Caldicot",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "PLDEB",
    "label": "Debica",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "CZULN",
    "label": "Usti Nad Labem",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "KRKPO",
    "label": "Pohang",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRGIN",
    "label": "GyeonginÃ¢Â ",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRKUV",
    "label": "Gunsan",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRUWN",
    "label": "Uiwang",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "KRTSN",
    "label": "Daesan",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "JPSHA",
    "label": "Shunan",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPWAK",
    "label": "Wakayama",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPTBT",
    "label": "Tobata",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPSJM",
    "label": "Sendai Shiogama-Miyagi",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "QAMES",
    "label": "MesaieedÃ¢Â ",
    "region": "Middle East & ISC",
    "country": "Qatar",
    "score": 0
  },
  {
    "unlocode": "JPIHA",
    "label": "Niihama",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "JPUBJ",
    "label": "Ube",
    "region": "Japan & Korea",
    "country": "Japan",
    "score": 0
  },
  {
    "unlocode": "ITCRM",
    "label": "Carmagnola",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "ITPMF",
    "label": "Parma",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "TRYPO",
    "label": "Yilport",
    "region": "Europe Med",
    "country": "Turkey",
    "score": 0
  },
  {
    "unlocode": "INSAC",
    "label": "Sachin",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INGAW",
    "label": "GuwahatiÃ¢Â ",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "INKAK",
    "label": "Kakinada",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "IDBKA",
    "label": "Bekasi",
    "region": "South East Asia",
    "country": "Indonesia",
    "score": 0
  },
  {
    "unlocode": "BRSVT",
    "label": "Sao Vicente",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "BRCUC",
    "label": "Caucaia",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "RUAZO",
    "label": "Azov",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUDYR",
    "label": "Anadyr",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUNER",
    "label": "Berkakit",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUBTK",
    "label": "Bratsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUCTA",
    "label": "Chita",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUEGV",
    "label": "Egvekinot",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKHO",
    "label": "Kholms",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKXK",
    "label": "Komsomolsk Na Amure",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUKSZ",
    "label": "Kotlas",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RULSS",
    "label": "Lesosibirsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUMAG",
    "label": "Magadansky, Port",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUMAS",
    "label": "Miass",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUNKI",
    "label": "Naushki",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUNEK",
    "label": "Nevinnomyssk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUNOK",
    "label": "Novotroitsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUOYA",
    "label": "Olya",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUPEZ",
    "label": "Penza",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUPKC",
    "label": "Petropavlovsk-Kamchatskiy",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUROV",
    "label": "Rostov",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUSAL",
    "label": "Salavat",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUSRT",
    "label": "Sarepta",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUBA5",
    "label": "Sterlitamak",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUTOX",
    "label": "Tobolsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUUSS",
    "label": "Ussuriisk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUUIK",
    "label": "Ust-Ilimsk",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "RUVND",
    "label": "Velikiy Novgorod",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  },
  {
    "unlocode": "UZCHU",
    "label": "Chukur-Say",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZALK",
    "label": "Angren",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "UZULU",
    "label": "Ulugbek",
    "region": "Central Asia",
    "country": "Uzbekistan",
    "score": 0
  },
  {
    "unlocode": "KZZHA",
    "label": "Zhanaaul",
    "region": "Central Asia",
    "country": "Kazakhstan",
    "score": 0
  },
  {
    "unlocode": "BYMVQ",
    "label": "Mogilev",
    "region": "Europe North",
    "country": "Belarus",
    "score": 0
  },
  {
    "unlocode": "BYOSH",
    "label": "Orsha",
    "region": "Europe North",
    "country": "Belarus",
    "score": 0
  },
  {
    "unlocode": "SEKOG",
    "label": "Koping",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "SEOSK",
    "label": "Oskarshamn",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "VNTOT",
    "label": "Cai Mep",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "COMZL",
    "label": "Manizales",
    "region": "Latin America West",
    "country": "Colombia",
    "score": 0
  },
  {
    "unlocode": "VNITX",
    "label": "Icd Transimex",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "VNTAM",
    "label": "Icd Tanamexco",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "TWMAL",
    "label": "Mai-Liai",
    "region": "North East Asia",
    "country": "Taiwan",
    "score": 0
  },
  {
    "unlocode": "MYIPH",
    "label": "Ipoh",
    "region": "South East Asia",
    "country": "Malaysia",
    "score": 0
  },
  {
    "unlocode": "BRGUR",
    "label": "Guaruja",
    "region": "Latin America East",
    "country": "Brazil",
    "score": 0
  },
  {
    "unlocode": "CWWIL",
    "label": "Willemstad (Curaçao)",
    "region": "Central America & Carribean",
    "country": "Curaçao",
    "score": 0
  },
  {
    "unlocode": "NLWAS",
    "label": "Wanssum",
    "region": "Europe North",
    "country": "Netherlands",
    "score": 0
  },
  {
    "unlocode": "GBLWT",
    "label": "West Thurrock",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "GBWAV",
    "label": "Watford Village",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "USADI",
    "label": "Arcadia, WI",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USUJV",
    "label": "Jamaica/Queens/New York, NY",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USLCA",
    "label": "La Canada-Flintridge, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USNXV",
    "label": "Nashville, IL",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USOAA",
    "label": "Onalaska, WA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "CACBK",
    "label": "Corner Brook, NL",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "PLKRK",
    "label": "Krakov",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "ITBUA",
    "label": "Busto Arsizio",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "BEKOU",
    "label": "Kallo",
    "region": "Europe North",
    "country": "Belgium",
    "score": 0
  },
  {
    "unlocode": "THKAN",
    "label": "Kantang",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 0
  },
  {
    "unlocode": "NOGLO",
    "label": "Glomfjord",
    "region": "Europe North",
    "country": "Norway",
    "score": 0
  },
  {
    "unlocode": "USANC",
    "label": "Anchorage, AK",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "FIKOK",
    "label": "Kokkola",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "SEPIT",
    "label": "Pitea",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "AUPER",
    "label": "Perth",
    "region": "Oceania",
    "country": "Australia",
    "score": 0
  },
  {
    "unlocode": "ITBZO",
    "label": "Bolzano",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "THSRI",
    "label": "Sriracha",
    "region": "South East Asia",
    "country": "Thailand",
    "score": 0
  },
  {
    "unlocode": "USWIL",
    "label": "Williston, VT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "FIPRS",
    "label": "Pietarsaari",
    "region": "Europe North",
    "country": "Finland",
    "score": 0
  },
  {
    "unlocode": "CMKBI",
    "label": "Kribi",
    "region": "West Africa",
    "country": "Cameroon",
    "score": 0
  },
  {
    "unlocode": "CAOTT",
    "label": "Ottawa, ON",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "CZMST",
    "label": "Most",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "DEBAM",
    "label": "Bamberg",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "DEHEN",
    "label": "Heilbronn",
    "region": "Europe North",
    "country": "Germany",
    "score": 0
  },
  {
    "unlocode": "ITPRD",
    "label": "Pordenone",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "LBKYE",
    "label": "Tripoli",
    "region": "Middle East & ISC",
    "country": "Lebanon",
    "score": 0
  },
  {
    "unlocode": "LTKUN",
    "label": "Kaunas",
    "region": "Europe North",
    "country": "Lithuania",
    "score": 0
  },
  {
    "unlocode": "PHMIC",
    "label": "Misamis Or./Cagayan De Oro",
    "region": "South East Asia",
    "country": "Philippines",
    "score": 0
  },
  {
    "unlocode": "SOBBO",
    "label": "Berbera",
    "region": "East Africa",
    "country": "Somalia",
    "score": 0
  },
  {
    "unlocode": "USDLH",
    "label": "Duluth, MN",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "USDLL",
    "label": "Dillon, SC",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "DOSDQ",
    "label": "Santo Domingo",
    "region": "Central America & Carribean",
    "country": "Dominican Republic",
    "score": 0
  },
  {
    "unlocode": "VNNGH",
    "label": "Nghi Son",
    "region": "South East Asia",
    "country": "Vietnam",
    "score": 0
  },
  {
    "unlocode": "SARYP",
    "label": "Riyadh Dry Port",
    "region": "Middle East & ISC",
    "country": "Saudi Arabia",
    "score": 0
  },
  {
    "unlocode": "INJUX",
    "label": "Basni",
    "region": "Middle East & ISC",
    "country": "India",
    "score": 0
  },
  {
    "unlocode": "KRGMG",
    "label": "Gwangmyeong",
    "region": "Japan & Korea",
    "country": "South Korea",
    "score": 0
  },
  {
    "unlocode": "USFCP",
    "label": "French Camp, CA",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "ITBRI",
    "label": "Bari",
    "region": "Europe Med",
    "country": "Italy",
    "score": 0
  },
  {
    "unlocode": "RSINI",
    "label": "Nis",
    "region": "Europe Med",
    "country": "Serbia",
    "score": 0
  },
  {
    "unlocode": "USBZN",
    "label": "Bozeman, MT",
    "region": "North America",
    "country": "United States",
    "score": 0
  },
  {
    "unlocode": "ATWER",
    "label": "Werndorf",
    "region": "Europe North",
    "country": "Austria",
    "score": 0
  },
  {
    "unlocode": "CZTRB",
    "label": "Trebic",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "CASEI",
    "label": "Sept-Iles, QC",
    "region": "North America",
    "country": "Canada",
    "score": 0
  },
  {
    "unlocode": "PLSAW",
    "label": "Slawkow",
    "region": "Europe North",
    "country": "Poland",
    "score": 0
  },
  {
    "unlocode": "CZMLK",
    "label": "Melnik",
    "region": "Europe North",
    "country": "Czech Republic",
    "score": 0
  },
  {
    "unlocode": "GBNCL",
    "label": "Newcastle Upon Tyne",
    "region": "Europe North",
    "country": "United Kingdom",
    "score": 0
  },
  {
    "unlocode": "SEKAN",
    "label": "Karlshamn",
    "region": "Europe North",
    "country": "Sweden",
    "score": 0
  },
  {
    "unlocode": "RUBRK",
    "label": "Lomonosov",
    "region": "Europe North",
    "country": "Russian Federation",
    "score": 0
  }
]
